window.theme = window.theme || {};
window.slate = window.slate || {};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },


  // Not from Slate, but fit in the a11y category
  lockMobileScrolling: function(namespace, $element) {
    if ($element) {
      var $el = $element;
    } else {
      var $el = $(document.documentElement).add('body');
    }
    $el.on('touchmove' + namespace, function () {
      return false;
    });
  },

  unlockMobileScrolling: function(namespace, $element) {
    if ($element) {
      var $el = $element;
    } else {
      var $el = $(document.documentElement).add('body');
    }
    $el.off(namespace);
  }
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
  createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (!container) {
      return;
    }

    this.createInstance(container);

    var instance = this._findInstance(evt.detail.sectionId);

    // Run JS only in case of the section being selected in the editor
    // before merchant clicks "Add"
    if (instance && typeof instance.onLoad === 'function') {
      instance.onLoad(evt);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = this._removeInstance(evt.detail.sectionId);
    if (instance && typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }
  },

  _onSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  _findInstance: function(id) {
    for (var i = 0; i < this.instances.length; i++) {
      if (this.instances[i].id === id) {
        return this.instances[i];
      }
    }
  },

  _removeInstance: function(id) {
    var i = this.instances.length;
    var instance;

    while(i--) {
      if (this.instances[i].id === id) {
        instance = this.instances[i];
        this.instances.splice(i, 1);
        break;
      }
    }

    return instance;
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this.createInstance(container, constructor);
    }.bind(this));
  }
});


/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '$';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();


/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element);
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    if (!src) {
      return '620x'; // default based on theme
    }

    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

slate.Variants = (function() {

  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.imageResolver = options.imageResolver;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    _setMasterSelectValue: function(variant) {
      var $field = $(this.originalSelectorId, this.$container);

      if (!$field.length) {
        return;
      }

      var variantId = variant && variant.id ? String(variant.id) : '';

      if (!$field.is('select')) {
        $field.val(variantId);
        return;
      }

      $field.find('option[data-synthetic-variant-option="true"]').remove();

      if (!variantId) {
        $field.val('');
        return;
      }

      var $matchingOption = $field.find('option').filter(function() {
        return String($(this).val() || '') === variantId;
      }).first();

      if (!$matchingOption.length) {
        $matchingOption = $('<option />', {
          value: variantId,
          'data-synthetic-variant-option': 'true'
        });
        $field.append($matchingOption);
      }

      $field.val(variantId);
    },

    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = this._compact(currentOptions);

      return currentOptions;
    },

    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var match = true;
        var options = variant.options;

        selectedValues.forEach(function(option) {
          // console.log('try to match ' + option.value + ' with ' + variant[option.index]);

          if (match) {
            match = (variant[option.index] === option.value);
          }
        });

        if (match) {
          found = variant;
        }
      });

      return found || null;
    },

    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        this._setMasterSelectValue(null);
        this.currentVariant = null;
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _updateImages: function(variant) {
      var resolveImage = this.imageResolver || function(targetVariant) {
        return targetVariant ? targetVariant.featured_image : null;
      };
      var variantImage = resolveImage(variant) || {};
      var currentVariantImage = resolveImage(this.currentVariant) || {};

      if (!variantImage.src || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
        image: variantImage
      });
    },
    
    _updatePrice: function(variant) {
      if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (this.currentVariant && variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    _updateMasterSelect: function(variant) {
      this._setMasterSelectValue(variant);
    },

    refresh: function() {
      this._onSelectChange();
    },

    // _.compact from lodash
    // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
    _compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
  });

  return Variants;
})();


/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="table-wrapper"></div>');
  }
};


theme.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closingClass: 'modal--is-closing',
      bodyOpenClass: 'modal-open',
      bodyOpenSolidClass: 'modal-open--solid',
      bodyClosingClass: 'modal-closing',
      closeOffContentClick: true
    };

    this.id = id;
    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body'),
      $modalContent: this.$modal.find('.modal__inner')
    };

    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', this.open.bind(this));
    this.$modal.find(this.config.close).on('click', this.close.bind(this));

    // Close modal if a drawer is opened
    $('body').on('drawerOpen', function() {
      this.close();
    }.bind(this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.$modal
      .prepareTransition()
      .addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.bodyOpenClass);

    if (this.isSolid) {
      this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;

    slate.a11y.trapFocus({
      $container: this.$modal,
      $elementToFocus: this.$focusOnOpen,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    $('body').trigger('modalOpen.' + this.id);

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal
      .prepareTransition()
      .removeClass(this.config.openClass)
      .addClass(this.config.closingClass);
    this.nodes.$parent.removeClass(this.config.bodyOpenClass);
    this.nodes.$parent.addClass(this.config.bodyClosingClass);
    var o = this;
    window.setTimeout(function() {
      o.nodes.$parent.removeClass(o.config.bodyClosingClass);
      o.$modal.removeClass(o.config.closingClass);
    }, 500); // modal close css transition

    if (this.isSolid) {
      this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;

    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    $('body').trigger('modalClose.' + this.id);

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$parent.on('keyup.modal', function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }.bind(this));

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.$modal.on('click.modal', this.close.bind(this));

      // Exception to above: clicking anywhere on the modal content will NOT close it
      this.nodes.$modalContent.on('click.modal', function(evt) {
        evt.stopImmediatePropagation();
      });
    }
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$parent.off('.modal');

    if (this.config.closeOffContentClick) {
      this.$modal.off('.modal');
      this.nodes.$modalContent.off('.modal');
    }
  };

  return Modal;
})();

theme.Drawers = (function() {
  function Drawer(id, name) {
    this.config = {
      id: id,
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + name,
      openClass: 'js-drawer-open',
      closingClass: 'js-drawer-closing',
      activeDrawer: 'drawer--is-open',
      namespace: '.drawer-' + name
    };

    this.$nodes = {
      parent: $(document.documentElement).add('body'),
      page: $('#MainContent')
    };

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.isOpen = false;
    this.init();
  };

  Drawer.prototype = $.extend({}, Drawer.prototype, {
    init: function() {
      var $openBtn = $(this.config.open);

      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');

      $openBtn.on('click', this.open.bind(this));
      this.$drawer.find(this.config.close).on('click', this.close.bind(this));
    },

    open: function(evt) {
      if (evt) {
        evt.preventDefault();
      }

      if (this.isOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }

      this.$drawer.prepareTransition().addClass(this.config.activeDrawer);

      this.$nodes.parent.addClass(this.config.openClass);
      this.isOpen = true;

      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      $('body').trigger('drawerOpen.' + this.config.id);

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      this.bindEvents();
    },

    close: function() {
      if (!this.isOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);

      this.$nodes.parent.removeClass(this.config.openClass);
      this.$nodes.parent.addClass(this.config.closingClass);
      var o = this;
      window.setTimeout(function() {
        o.$nodes.parent.removeClass(o.config.closingClass);
      }, 500);

      this.isOpen = false;

      slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false');
      }

      this.unbindEvents();
    },

    bindEvents: function() {
      slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);

      // Clicking out of drawer closes it
      this.$nodes.page.on('click' + this.config.namespace, function () {
        this.close();
        return false;
      }.bind(this));

      // Pressing escape closes drawer
      this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
    },

    unbindEvents: function() {
      slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
      this.$nodes.parent.off(this.config.namespace);
    }
  });

  return Drawer;
})();

theme.cart = {
  getCart: function() {
    return $.getJSON('/cart.js');
  },

  changeItem: function(key, qty) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + key,
      dataType: 'json'
    });
  },

  addItemFromForm: function(data) {
    var requestData = data;
    var sourceForm = null;

    if ($.isPlainObject(data) && typeof data.data !== 'undefined') {
      requestData = data.data;
      sourceForm = data.sourceForm || null;
    }

    if (sourceForm) {
      var $sourceForm = sourceForm.jquery ? sourceForm : $(sourceForm);
      var sourceFormElement = $sourceForm.length ? $sourceForm[0] : null;
      var productController = $sourceForm.data('themeProductController') || (sourceFormElement && sourceFormElement.__themeProductController);

      if (productController && typeof productController.validateProductFormSubmission === 'function') {
        var validation = productController.validateProductFormSubmission({
          reason: 'ajax-cart-helper',
          focusOnError: true
        });

        if (!validation.valid) {
          var deferred = $.Deferred();
          deferred.reject({
            responseJSON: {
              description: validation.message || 'Please review the bespoke selection before adding to cart.'
            }
          });
          return deferred.promise();
        }
      }
    }

    return this._updateCart({
      type: 'POST',
      url: '/cart/add.js',
      data: requestData,
      dataType: 'json'
    });
  },

  _updateCart: function(params) {
    return $.ajax(params)
      .then(function(cart) {
        return cart;
      }.bind(this))
  },

  updateNote: function(note) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        note: this.attributeToString(note)
      },
      dataType: 'json'
    });
  },

  updateAttribute: function(attributeName, value) {
    var data = {};
    data['attributes[' + attributeName + ']'] = this.attributeToString(value);

    return this._updateCart({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json'
    });
  },

  normalizeCartItemText: function(value) {
    return this.attributeToString(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/^\s+|\s+$/g, '');
  },

  containsAnyTerm: function(value, terms) {
    var paddedValue = ' ' + value + ' ';
    for (var i = 0; i < terms.length; i++) {
      if (paddedValue.indexOf(' ' + terms[i] + ' ') !== -1) {
        return true;
      }
    }
    return false;
  },

  isHeightEligibleCartItem: function(item) {
    if (!item) {
      return false;
    }

    var normalizedType = this.normalizeCartItemText(item.product_type || '');
    var normalizedTitle = this.normalizeCartItemText(item.product_title || item.title || '');
    var typeTerms = ['dress', 'dresses', 'jumpsuit', 'jumpsuits', 'one piece', 'one pieces', 'onepiece', 'onepieces'];
    var titleTerms = ['dress', 'dresses', 'jumpsuit', 'jumpsuits'];

    return this.containsAnyTerm(normalizedType, typeTerms) || this.containsAnyTerm(normalizedTitle, titleTerms);
  },

  cartRequiresHeightAttribute: function(items) {
    if (!items || !items.length) {
      return false;
    }

    for (var i = 0; i < items.length; i++) {
      if (this.isHeightEligibleCartItem(items[i])) {
        return true;
      }
    }

    return false;
  },

  getHeightAttributeValue: function(cartData) {
    if (!cartData || !cartData.attributes || cartData.attributes.Height == null) {
      return '';
    }

    return this.attributeToString(cartData.attributes.Height);
  },

  variantTitleContainsInternalBespoke: function(variantTitle) {
    var normalizedVariantTitle = this.attributeToString(variantTitle);

    if (!normalizedVariantTitle || normalizedVariantTitle === 'Default Title') {
      return false;
    }

    var variantParts = normalizedVariantTitle.split('/');

    for (var i = 0; i < variantParts.length; i++) {
      if (this.attributeToString(variantParts[i]).toLowerCase() === 'bespoke') {
        return true;
      }
    }

    return false;
  },

  getDisplayVariantTitle: function(variantTitle) {
    var normalizedVariantTitle = this.attributeToString(variantTitle);

    if (!normalizedVariantTitle || normalizedVariantTitle === 'Default Title') {
      return '';
    }

    var variantParts = normalizedVariantTitle.split('/');
    var visibleVariantParts = [];

    for (var i = 0; i < variantParts.length; i++) {
      var normalizedPart = this.attributeToString(variantParts[i]);
      var normalizedPartKey = normalizedPart.toLowerCase();

      if (!normalizedPart || normalizedPartKey === 'default title' || normalizedPartKey === 'bespoke') {
        continue;
      }

      visibleVariantParts.push(normalizedPart);
    }

    if (visibleVariantParts.length) {
      return visibleVariantParts.join(' / ');
    }

    return normalizedVariantTitle.toLowerCase() === 'bespoke' ? '' : normalizedVariantTitle;
  },

  getDisplayMetaLines: function(variantTitle, properties) {
    var metaLines = [];
    var fabricValue = '';
    var hasBespokeMarker = this.variantTitleContainsInternalBespoke(variantTitle);
    var visibleVariantTitle = this.getDisplayVariantTitle(variantTitle);

    if (properties) {
      $.each(properties, function(key, value) {
        var normalizedValue = theme.cart.attributeToString(value);

        if (!normalizedValue) {
          return;
        }

        if (key === 'Fabric') {
          fabricValue = normalizedValue;
          hasBespokeMarker = true;
          return;
        }

        if (key === '_bespoke') {
          hasBespokeMarker = true;
        }
      });
    }

    if (fabricValue) {
      metaLines.push('Fabric: ' + fabricValue);
    } else if (hasBespokeMarker) {
      metaLines.push('Fabric: Bespoke selection');
    }

    if (visibleVariantTitle) {
      metaLines.push(visibleVariantTitle);
    }

    if (properties) {
      $.each(properties, function(key, value) {
        var normalizedValue = theme.cart.attributeToString(value);

        if (!normalizedValue || key.charAt(0) === '_' || key === 'Fabric') {
          return;
        }

        metaLines.push(key + ': ' + normalizedValue);
      });
    }

    return metaLines;
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return $.trim(attribute);
  }
}

$(function() {
  var heightAttributeName = 'Height';
  var heightFieldSelector = '[name="attributes[' + heightAttributeName + ']"]';
  var heightUpdateTimer = null;

  // Add a loading indicator on the cart checkout button (/cart and drawer)
  $('body').on('click', '.cart__checkout', function() {
    $(this).addClass('btn--loading');
  });

  $('body').on('change', 'textarea[name="note"]', function() {
    var newNote = $(this).val();
    theme.cart.updateNote(newNote);
  });

  $('body').on('input', heightFieldSelector, function() {
    var newHeight = $(this).val();
    clearTimeout(heightUpdateTimer);
    heightUpdateTimer = setTimeout(function() {
      theme.cart.updateAttribute(heightAttributeName, newHeight);
    }, 250);
  });

  $('body').on('change', heightFieldSelector, function() {
    clearTimeout(heightUpdateTimer);
    theme.cart.updateAttribute(heightAttributeName, $(this).val());
  });

  if ($('input[data-cart-height-clear="true"]').length) {
    theme.cart.updateAttribute(heightAttributeName, '');
  }
});

theme.QtySelector = (function() {
  var classes = {
    input: '.js-qty__num',
    plus: '.js-qty__adjust--plus',
    minus: '.js-qty__adjust--minus'
  };

  function QtySelector($el, options) {
    this.$wrapper = $el;
    this.$originalInput = $el.find('input[type="number"]');
    this.minValue = this.$originalInput.attr('min') || 1;

    var defaults = {
      namespace: null
    };

    this.options = $.extend(defaults, options);

    this.source = $('#JsQty').html();
    this.template = Handlebars.compile(this.source);

    var quantities = {
      current: this._getOriginalQty(),
      add: this._getOriginalQty() + 1,
      minus: this._getOriginalQty() - 1
    };

    this.data = {
      key: this._getProductKey(),
      itemQty: quantities.current,
      itemAdd: quantities.add,
      itemMinus: quantities.minus,
      inputName: this._getInputName(),
      inputId: this._getId()
    }

    // Append new quantity selector then remove original
    this.$originalInput.after(this.template(this.data)).remove();
    this.$input = this.$wrapper.find(classes.input);
    this.$plus = this.$wrapper.find(classes.plus);
    this.$minus = this.$wrapper.find(classes.minus);

    this.initEventListeners();
  };

  QtySelector.prototype = $.extend({}, QtySelector.prototype, {
    _getProductKey: function() {
      return this.$originalInput.data('id') || null;
    },

    _getOriginalQty: function() {
      return parseInt(this.$originalInput.val());
    },

    _getInputName: function() {
      return this.$originalInput.attr('name');
    },

    _getId: function() {
      return this.$originalInput.attr('id');
    },

    initEventListeners: function() {
      this.$plus.on('click', function() {
        var qty = this.validateQty(this.$input.val());
        this.addQty(qty);
      }.bind(this));

      this.$minus.on('click', function() {
        var qty = this.validateQty(this.$input.val());
        this.subtractQty(qty);
      }.bind(this));

      this.$input.on('change', function() {
        var qty = this.validateQty(this.$input.val());
        this.changeQty(qty);
      }.bind(this));
    },

    addQty: function(number) {
      var qty = number + 1;
      this.changeQty(qty);
    },

    subtractQty: function(number) {
      var qty = number - 1;
      if (qty <= this.minValue) {
        qty = this.minValue;
      }
      this.changeQty(qty);
    },

    changeQty: function(qty) {
      this.$input.val(qty);
      $('body').trigger('qty' + this.options.namespace, [this.data.key, qty]);
    },

    validateQty: function(number) {
      if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
        // We have a valid number!
      } else {
        // Not a number. Default to 1.
        number = 1;
      }
      return parseInt(number);
    }
  });

  return QtySelector;
})();

theme.CartDrawer = (function() {
  var config = {
    namespace: '.ajaxcart'
  };

  var selectors = {
    drawer: '#CartDrawer',
    container: '#CartContainer',
    template: '#CartTemplate',
    fixedFooter: '.drawer__footer--fixed',
    fixedInnerContent: '.drawer__inner--has-fixed-footer',
    cartBubble: '.cart-link__bubble'
  };

  function CartDrawer() {
    this.status = {
      loaded: false,
      loading: false,
      syncingHeightAttribute: false
    };

    this.qtySelectors = [];

    this.drawer = new theme.Drawers('CartDrawer', 'cart');

    // Prep handlebars template
    var source = $(selectors.template).html();
    this.template = Handlebars.compile(source);

    // Build cart on page load so it's ready in the drawer
    if (!theme.config.isIframe) {
      theme.cart.getCart().then(this.buildCart.bind(this));
    }

    this.initEventListeners();
  };

  CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
    initEventListeners: function() {
      $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
      $('body').on('updateCart' + config.namespace, this.sizeFooter.bind(this));
      $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
      $('body').on('updateCart' + config.namespace, this.syncHeightAttributeClear.bind(this));
      $('body').on('drawerOpen.CartDrawer', this.sizeFooter.bind(this));

      $(window).on('resize' + config.namespace, $.debounce(150, this.sizeFooter.bind(this)));

      $('body').on('added.ajaxProduct', function() {
        theme.cart.getCart().then(function(cart) {
          this.buildCart(cart, true);
        }.bind(this));
      }.bind(this));
    },

    buildCart: function(cart, openDrawer) {
      this.loading(true);
      this.emptyCart();

      if (cart.item_count === 0) {
        $(selectors.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty +'</p>');
      } else {
        var items = [];
        var item = {};
        var data = {};
        var animation_row = 1;
        var showHeightField = theme.cart.cartRequiresHeightAttribute(cart.items);
        var heightAttribute = theme.cart.getHeightAttributeValue(cart);
        var shouldClearHeightAttribute = !showHeightField && heightAttribute !== '';

        $.each(cart.items, function(index, product) {

          var prodImg;
          if (product.image !== null) {
            prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
          } else {
            prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
          }

          animation_row+=2;

          item = {
            key: product.key,
            url: product.url,
            img: prodImg,
            animationRow: animation_row,
            name: product.product_title,
            metaLines: theme.cart.getDisplayMetaLines(product.variant_title, product.properties),
            itemQty: product.quantity,
            price: theme.Currency.formatMoney(product.price, theme.settings.moneyFormat),
            discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
            discounts: product.discounts,
            discountsApplied: product.price === (product.price - product.total_discount) ? false : true,
            vendor: product.vendor
          };

          items.push(item);
        });

        animation_row+=2;

        data = {
          items: items,
          note: cart.note,
          showHeightField: showHeightField,
          heightAttribute: heightAttribute,
          shouldClearHeightAttribute: shouldClearHeightAttribute,
          lastAnimationRow: animation_row,
          totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat),
          totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings.replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat))
        };

        $(selectors.container).append(this.template(data));
      }

      this.status.loaded = true;
      this.loading(false);

      if ($('body').hasClass('currencies-enabled')) {
        theme.currencySwitcher.ajaxrefresh();
      }

      $('body').trigger('updateCart' + config.namespace, cart);

      // If specifically asked, open the cart drawer (only happens after product added from form)
      if (openDrawer === true) {
        this.drawer.open();
      }
    },

    initQtySelectors: function() {
      this.qtySelectors = [];

      $(selectors.container).find('.js-qty').each(function(index, el) {
        var selector = new theme.QtySelector($(el), {
          namespace: '.cart-drawer'
        });
        this.qtySelectors.push(selector);
      }.bind(this));

      $('body').on('qty.cart-drawer', this.updateItem.bind(this));
    },

    updateItem: function(evt, key, qty) {
      if (this.status.loading) {
        return;
      }

      this.loading(true);

      theme.cart.changeItem(key, qty)
        .then(function(cart) {
          this.updateSuccess(cart);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.updateError(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          this.loading(false);
        }.bind(this));
    },

    syncHeightAttributeClear: function() {
      if (this.status.syncingHeightAttribute) {
        return;
      }

      if (!$(selectors.container).find('input[data-cart-height-clear="true"]').length) {
        return;
      }

      this.status.syncingHeightAttribute = true;
      theme.cart.updateAttribute('Height', '')
        .then(function(cart) {
          this.buildCart(cart);
        }.bind(this))
        .always(function() {
          this.status.syncingHeightAttribute = false;
        }.bind(this));
    },

    loading: function(state) {
      this.status.loading = state;

      if (state) {
        $(selectors.container).addClass('is-loading');
      } else {
        $(selectors.container).removeClass('is-loading');
      }
    },

    emptyCart: function() {
      $(selectors.container).empty();
    },

    updateSuccess: function(cart) {
      this.buildCart(cart)
    },

    updateError: function(XMLHttpRequest) {
      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);
      }
    },

    // Update elements after cart is updated
    sizeFooter: function() {
      // Stop if our drawer doesn't have a fixed footer
      if (!$(selectors.drawer).hasClass('drawer--has-fixed-footer')) {
        return;
      }

      // Elements are reprinted regularly so selectors are not cached
      var $cartFooter = $(selectors.drawer).find(selectors.fixedFooter).removeAttr('style');
      var $cartInner = $(selectors.drawer).find(selectors.fixedInnerContent).removeAttr('style');
      var cartFooterHeight = $cartFooter.outerHeight();

      $cartInner.css('bottom', cartFooterHeight);
      $cartFooter.css('height', cartFooterHeight);
    },

    updateCartNotification: function(evt, cart) {
      if (cart.items.length > 0) {
        $(selectors.cartBubble).addClass('cart-link__bubble--visible');
      } else {
        $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
      }
    }
  });

  return CartDrawer;
})();

theme.AjaxProduct = (function() {
  var status = {
    loading: false
  };

  function ProductForm($form) {
    this.$form = $form;
    this.$addToCart = this.$form.find('.add-to-cart');

    if (this.$form.length) {
      this.$form.on('submit', this.addItemFromForm.bind(this));
    }
  };

  ProductForm.prototype = $.extend({}, ProductForm.prototype, {
    addItemFromForm: function(evt, callback){
      if (evt && typeof evt.preventDefault === 'function') {
        evt.preventDefault();
      }

      if (status.loading) {
        console.warn('already adding item to cart | bail');
        return;
      }

      var formElement = this.$form.length ? this.$form[0] : null;
      var productController = this.$form.data('themeProductController') || (formElement && formElement.__themeProductController);

      if (productController && typeof productController.validateProductFormSubmission === 'function') {
        var validation = productController.validateProductFormSubmission({
          reason: 'ajax-product-submit',
          focusOnError: true
        });

        if (!validation.valid) {
          this.error({
            responseJSON: {
              description: validation.message || 'Please review the bespoke selection before adding to cart.'
            }
          });
          return;
        }
      }

      // Loading indicator on add to cart button
      this.$addToCart.addClass('btn--loading');

      status.loading = true;

      var data = this.$form.serialize();

      theme.cart.addItemFromForm({
        data: data,
        sourceForm: this.$form
      })
        .then(function(product) {
          this.success(product);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.error(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          status.loading = false;
          this.$addToCart.removeClass('btn--loading');
        }.bind(this));
    },

    success: function(product) {
      this.$form.find('.errors').remove();
      $('body').trigger('added.ajaxProduct');
    },

    error: function(XMLHttpRequest) {
      this.$form.find('.errors').remove();

      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);

        this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
      }
    }
  });

  return ProductForm;
})();

theme.collapsibles = (function() {

  var selectors = {
    trigger: '.collapsible-trigger',
    module: '.collapsible-content',
    moduleInner: '.collapsible-content__inner'
  };

  var classes = {
    hide: 'hide',
    open: 'is-open',
    autoHeight: 'collapsible--auto-height'
  };

  var isTransitioning = false;

  function init() {
    $(selectors.trigger).each(function() {
      var $el = $(this);
      var state = $el.hasClass(classes.open);
      $el.attr('aria-expanded', state);
    });

    // Event listeners (hack for modals)
    $('body, .modal__inner').on('click', selectors.trigger, function() {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var $el = $(this);
      var isOpen = $el.hasClass(classes.open);
      var moduleId = $el.attr('aria-controls');
      var $module = $('#' + moduleId);
      var height = $module.find(selectors.moduleInner).outerHeight();
      var isAutoHeight = $el.hasClass(classes.autoHeight);

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight($module, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      $el
        .attr('aria-expanded', !isOpen)
        .toggleClass(classes.open, !isOpen);

      setTransitionHeight($module, height, isOpen, isAutoHeight);
    });
  }

  function setTransitionHeight($module, height, isOpen, isAutoHeight) {
    $module
      .removeClass(classes.hide)
      .prepareTransition()
      .css('height', height)
      .toggleClass(classes.open, !isOpen);

    if (!isOpen && isAutoHeight) {
      var o = $module;
      window.setTimeout(function() {
        o.css('height','auto');
        isTransitioning = false;
      }, 500);
    } else {
      isTransitioning = false;
    }
  }

  return {
    init: init
  };
})();

theme.headerNav = (function() {

  var $parent = $(document.documentElement).add('body');
  var $page = $('#MainContent');
  var selectors = {
    wrapper: '.header-wrapper',
    siteHeader: '.site-header',
    searchBtn: '.js-search-header',
    closeSearch: '.js-search-header-close',
    searchContainer: '.site-header__search-container',
    logoContainer: '.site-header__logo',
    logo: '.site-header__logo img',
    navigation: '.site-navigation',
    navContainerWithLogo: '.header-item--logo',
    navLinks: '.site-nav__link',
    navDropdownLinks: '.site-nav__dropdown-link--second-level',

    hasDropdownClass: 'site-nav--has-dropdown',
    hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
    reverseLastDropdown: 'header-item--reverse'
  };

  var config = {
    namespace: '.siteNav',
    wrapperOverlayed: false,
    overlayedClass: 'is-light',
    stickyEnabled: false,
    stickyActive: false,
    stickyClass: 'site-header--stuck',
    openTransitionClass: 'site-header--opening',
    lastScroll: 0
  };

  // Elements used in resize functions, defined in init
  var $window;
  var $navContainerWithLogo;
  var $logoContainer;
  var $nav;
  var $wrapper;
  var $siteHeader;

  function init() {
    $window = $(window);
    $navContainerWithLogo = $(selectors.navContainerWithLogo);
    $logoContainer = $(selectors.logoContainer);
    $nav = $(selectors.navigation);
    $wrapper = $(selectors.wrapper);
    $siteHeader = $(selectors.siteHeader);

    var enableFitNav = $(selectors.navigation).hasClass('site-nav--activate-compress');

    if (enableFitNav) {
      fitNav();
      $window.on('load' + config.namespace, fitNav);
      $window.on('resize' + config.namespace, $.debounce(150, fitNav));
    }

    config.stickyEnabled = $siteHeader.data('sticky');
    if (config.stickyEnabled) {
      config.wrapperOverlayed = $wrapper.hasClass(config.overlayedClass);
      stickyHeader();
    }

    accessibleDropdowns();
    searchDrawer();

    $window.on('load' + config.namespace, resizeLogo);
    $window.on('resize' + config.namespace, $.debounce(150, resizeLogo));
  }

  function unload() {
    $(window).off(config.namespace);
    $(selectors.searchBtn).off(config.namespace);
    $(selectors.closeSearch).off(config.namespace);
    $parent.off(config.namespace);
    $(selectors.navLinks).off(config.namespace);
    $(selectors.navDropdownLinks).off(config.namespace);
  }

  function searchDrawer() {
    $(selectors.searchBtn).on('click' + config.namespace, function(evt) {
      evt.preventDefault();
      openSearchDrawer();
    });

    $(selectors.closeSearch).on('click' + config.namespace, function() {
      closeSearchDrawer();
    });
  }

  function openSearchDrawer() {
    $(selectors.searchContainer).addClass('is-active');
    $parent.addClass('js-drawer-open js-drawer-open--search');

    slate.a11y.trapFocus({
      $container: $(selectors.searchContainer),
      namespace: 'header_search',
      $elementToFocus: $(selectors.searchContainer).find('input')
    });

    // If sticky is enabled, scroll to top on mobile when close to it
    // so you don't get an invisible search box
    if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
      window.scrollTo(0,0);
    }

    // Bind events
    slate.a11y.lockMobileScrolling(config.namespace);

    // Clicking out of container closes it
    $page.on('click' + config.namespace, function () {
      closeSearchDrawer();
      return false;
    });

    $parent.on('keyup' + config.namespace, function(evt) {
      if (evt.keyCode === 27) {
        closeSearchDrawer();
      }
    });
  }

  function closeSearchDrawer() {
    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    $parent.removeClass('js-drawer-open js-drawer-open--search').off(config.namespace);
    $(selectors.searchContainer).removeClass('is-active');

    slate.a11y.removeTrapFocus({
      $container: $(selectors.searchContainer),
      namespace: 'header_search'
    });

    slate.a11y.unlockMobileScrolling(config.namespace);
    $page.off('click' + config.namespace);
    $parent.off('keyup' + config.namespace);
  }

  function resizeLogo() {
    // Using .each() as there can be a reversed logo too
    $(selectors.logo).each(function() {
      var $el = $(this),
          logoWidthOnScreen = $el.width(),
          containerWidth = $el.closest('.grid__item').width();
      // If image exceeds container, let's make it smaller
      if (logoWidthOnScreen > containerWidth) {
        $el.css('maxWidth', containerWidth);
      }
      else {
        $el.removeAttr('style');
      }
    });
  }

  function fitNav() {
    // Measure children of site nav on load and resize.
    // If wider than parent (minus logo), switch to mobile nav.
    // Subtract 20 from width to account for inline-block spacing
    var availableNavSpace = $navContainerWithLogo.width() - $logoContainer.outerWidth() - 20;
    var navItemWidth = 0;
    $nav.find('> li').each(function() {
      var $el = $(this);
      if (!$el.hasClass('site-nav--compress__menu')) {
        // Round up to be safe
        navItemWidth += Math.ceil($(this).width());
      }
    });

    // Set class to make third level nav float to left so it stays in the screen
    if ((availableNavSpace - navItemWidth) < 180) {
      $navContainerWithLogo.addClass(selectors.reverseLastDropdown)
    } else {
      $navContainerWithLogo.removeClass(selectors.reverseLastDropdown)
    }

    if (navItemWidth > availableNavSpace) {
      $wrapper.addClass('site-nav--compress');
    } else {
      $wrapper.removeClass('site-nav--compress');
    }
  }

  function accessibleDropdowns() {
    var hasActiveDropdown = false;
    var hasActiveSubDropdown = false;

    // Open/hide top level dropdowns
    $(selectors.navLinks).on('focusin' + config.namespace, function() {
      if (hasActiveDropdown) {
        closeSecondLevelDropdown();
      }

      if (hasActiveSubDropdown) {
        closeThirdLevelDropdown();
      }

      if ($(this).parent().hasClass(selectors.hasDropdownClass)) {
        $(this).addClass('is-focused');
        hasActiveDropdown = true;
      }
    });

    // Open/hide sub level dropdowns
    $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
      if (hasActiveSubDropdown) {
        closeThirdLevelDropdown();
      }

      if ($(this).parent().hasClass(selectors.hasSubDropdownClass)) {
        $(this).addClass('is-focused');
        hasActiveSubDropdown = true;
      }
    });

    // Private dropdown methods
    function closeSecondLevelDropdown() {
      $(selectors.navLinks).removeClass('is-focused');
    }

    function closeThirdLevelDropdown() {
      $(selectors.navDropdownLinks).removeClass('is-focused');
    }
  }

  function stickyHeader() {
    config.lastScroll = 0;
    $siteHeader.wrap('<div class="site-header-sticky"></div>');
    var $stickyHeader = $('.site-header-sticky').css('height', $siteHeader.outerHeight(true));

    $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
  }

  function stickyHeaderScroll() {
    var scroll = $window.scrollTop();
    var threshold = 250;

    if (scroll > threshold) {
      if (config.stickyActive) {
        return;
      }

      config.stickyActive = true;

      $siteHeader.addClass(config.stickyClass);
      if (config.wrapperOverlayed) {
        $wrapper.removeClass(config.overlayedClass);
      }

      // Add open transition class after element is set to fixed
      // so CSS animation is applied correctly
      setTimeout(function() {
        $siteHeader.addClass(config.openTransitionClass);
      }, 100);
    } else {
      if (!config.stickyActive) {
        return;
      }

      config.stickyActive = false;

      $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
      if (config.wrapperOverlayed) {
        $wrapper.addClass(config.overlayedClass);
      }
    }

    config.lastScroll = scroll;
  }

  return {
    init: init,
    unload: unload
  };
})();

theme.articleImages = (function() {

  var cache = {};

  function init() {
    cache.$rteImages = $('.rte--indented-images');

    if (!cache.$rteImages.length) {
      return;
    }

    $(window).on('load', setImages);
  }

  function setImages() {
    cache.$rteImages.find('img').each(function() {
      var $el = $(this);
      var attr = $el.attr('style');

      // Check if undefined or float: none
      if (!attr || attr == 'float: none;') {
        // Remove grid-breaking styles if image isn't wider than parent
        if ($el.width() < cache.$rteImages.width()) {
          $el.addClass('rte__no-indent');
        }
      }
    });
  }

  return {
    init: init
  };
})();

theme.backButton = (function() {

  function init() {
    if (!document.referrer || !$('.return-link').length || !window.history.length) {
      return;
    }

    //$('.return-link').on('click', backHistory);
  }

  function backHistory() {
    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(document.url);

    if (shopDomain === referrerDomain) {
      history.back();
      return false;
    }
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }

  return {
    init: init
  };
})();

theme.Slideshow = (function() {
  this.$slideshow = null;

  var classes = {
    next: 'is-next',
    init: 'is-init',
    header: 'header-wrapper',
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el, args) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      // fade: true,
      draggable: true,
      touchThreshold: 5,
      pauseonHover: false,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('init', this.init.bind(this));

    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this._togglePause.bind(this));
  }

  slideshow.prototype = $.extend({}, slideshow.prototype, {
    init: function(event, obj) {
      this.$slideshowList = obj.$list;
      this.$slickDots = obj.$dots;
      this.$allSlides = obj.$slides;
      this.slideCount = obj.slideCount;

      this.$slideshow.addClass(classes.init);
      // this._currentSlide().addClass('is-first');
      this._a11y();
    },
    destroy: function() {
      this.$slideshow.slick('unslick');
    },

    // Playback
    _play: function() {
      this.$slideshow.slick('slickPause');
      $(classes.pauseButton).addClass('is-paused');
    },
    _pause: function() {
      this.$slideshow.slick('slickPlay');
      $(classes.pauseButton).removeClass('is-paused');
    },
    _togglePause: function() {
      var slideshowSelector = this._getSlideshowId(this.$pause);
      if (this.$pause.hasClass(classes.isPaused)) {
        this.$pause.removeClass(classes.isPaused);
        $(slideshowSelector).slick('slickPlay');
      } else {
        this.$pause.addClass(classes.isPaused);
        $(slideshowSelector).slick('slickPause');
      }
    },

    // Helpers
    _getSlideshowId: function($el) {
      return '#Slideshow-' + $el.data('id');
    },
    _activeSlide: function() {
      return this.$slideshow.find('.slick-active');
    },
    _currentSlide: function() {
      return this.$slideshow.find('.slick-current');
    },
    _nextSlide: function(index) {
      return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
    },

    // a11y fixes
    _a11y: function() {
      var $list = this.$slideshowList;
      var autoplay = this.settings.autoplay;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live
      $(classes.wrapper).on('focusin', function(evt) {
        if (!$(classes.wrapper).has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');
        if (autoplay) {
          this._pause();
        }
      }.bind(this));

      // Resume autoplay
      $(classes.wrapper).on('focusout', function(evt) {
        if (!$(classes.wrapper).has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');
        if (autoplay) {
          this._play();
        }
      }.bind(this));
    }
  });

  return slideshow;
})();

theme.announcementBar = (function() {

  var selectors = {
    announcementBar: '.announcement',
    announcementText: '.announcement__text',
    announcementClose: '.announcement__close'
  }

  function init() {
    if (!$(selectors.announcementClose).length) {
      return;
    }

    if (theme.config.isIframe) {
      announcementBarShow();
      return;
    }

    if (!theme.config.hasSessionStorage || sessionStorage[announcementBarText()] !== 'hidden') {
      announcementBarShow();
    }

    $(selectors.announcementClose).on('click', function(evt) {
      evt.preventDefault();
      announcementBarClose();
    });
  }

  function announcementBarShow() {
    var $announcementBar = $(selectors.announcementBar);
    var text = $.trim($(selectors.announcementText).text());

    // Defensive guard: never leave a tiny/empty strip at the top.
    if (!text.length) {
      announcementBarClose();
      return;
    }

    $announcementBar
      .removeClass('announcement--closed')
      .addClass('announcement--opening')
      .css({height: 'auto'});

    var barHeight = $announcementBar.outerHeight();

    $announcementBar
      .css({height: 0})
      .prepareTransition()
      .css({height: barHeight});

    // Keep dynamic text wrapping from reintroducing tiny leftover gaps.
    window.setTimeout(function() {
      var settledHeight = $announcementBar.outerHeight();
      if (settledHeight <= 14) {
        announcementBarClose();
        return;
      }
      $announcementBar.css({height: 'auto'});
    }, 550);
  }

  function announcementBarClose() {
    if (theme.config.hasSessionStorage) {
      sessionStorage.setItem(announcementBarText(), 'hidden');
    }

    var $announcementBar = $(selectors.announcementBar);
    var barHeight = $announcementBar.outerHeight();

    $announcementBar
      .css({height: barHeight})
      .prepareTransition()
      .addClass('announcement--closed')
      .removeClass('announcement--opening')
      .css({height: 0});
  }

  function announcementBarText() {
    return $(selectors.announcementText).data('text');
  }

  return {
    init: init
  };
})();

theme.currencySwitcher = (function() {

  var selectors = {
    dataDiv: '#CurrencyData',
    picker: '.currency-input'
  };

  var data = {};

  function init() {
    var $dataDiv = $(selectors.dataDiv);

    if (!$dataDiv.length) {
      return;
    }

    $primaryPicker = $('#CurrencyPicker-header');
    $secondaryPicker = $('#CurrencyPicker-footer');

    // Keep primary and secondary currency pickers in sync
    if ($secondaryPicker.length) {
      $secondaryPicker.on('change', function() {
        $primaryPicker.val($(this).val());
      });

      $primaryPicker.on('change', function() {
        $secondaryPicker.val($(this).val());
      });
    }

    data = {
      currency: $dataDiv.data('shop-currency'),
      default: $dataDiv.data('default-currency'),
      format: $dataDiv.data('format'),
      moneyFormat: $dataDiv.data('money-format'),
      moneyCurrencyFormat: $dataDiv.data('money-currency-format')
    };

    Currency.format = data.format;

    // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
    Currency.money_format[data.currency] = data.moneyFormat;
    Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;

    // Fix for customer account page
    $('span.money span.money').each(function() {
      $(this).parents('span.money').removeClass('money');
    });

    // Save current price
    $('span.money').each(function() {
      $(this).attr('data-currency-' + data.currency, $(this).html());
    });

    checkCookie();

    $(selectors.picker).val(Currency.currentCurrency).on('change', refresh);
  }

  function refresh() {
    var newCurrency = $(selectors.picker).val();
    Currency.convertAll(Currency.currentCurrency, newCurrency);
  }

  function ajaxrefresh() {
    var newCurrency = $(selectors.picker).val();
    // Ajax cart always returns shop's currency, not what theme settings defines
    Currency.convertAll(data.currency, newCurrency);
  }

  function checkCookie() {
    var cookieCurrency = Currency.cookie.read();

    if (cookieCurrency == null) {
      if (data.currency !== data.default) {
        Currency.convertAll(data.currency, data.default);
      }
      else {
        Currency.currentCurrency = data.default;
      }
    } else if ($(selectors.picker).length && $(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
      // If the cookie value does not correspond to any value in the currency dropdown
      Currency.currentCurrency = data.currency;
      Currency.cookie.write(data.currency);
    }
    else if (cookieCurrency === data.currency) {
      Currency.currentCurrency = data.currency;
    }
    else {
      Currency.convertAll(data.currency, cookieCurrency);
    }
  }

  return {
    init: init,
    refresh: refresh,
    ajaxrefresh: ajaxrefresh
  };
})();

theme.initQuickShop = function() {
  $('.quick-product__btn').each(function() {
    var productId = $(this).data('product-id');
    var modalId = 'QuickShopModal-' + productId;
    var modalName = 'quick-modal-' + productId;
    new theme.Modals(modalId, modalName);
  });
};

theme.videoModal = function() {
  var videoModalPlayer = null;
  var videoOptions = {
    width: 1280,
    height: 720,
    playerVars: {
      autohide: 0,
      autoplay: 1,
      branding: 0,
      cc_load_policy: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    }
  };

  var selectors = {
    triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
  };

  if (!$(selectors.triggers).length) {
    return;
  }

  var modal = new theme.Modals('VideoModal', 'video-modal', {
    closeOffContentClick: true,
    solid: true
  });

  // We have at least one video that may open in a modal. Prep YouTube API
  window.loadYouTube();
  $('body').on('youTubeReady', function() {
    $(selectors.triggers).on('click', startVideoOnClick);
  });

  function startVideoOnClick(evt) {
    evt.preventDefault();
    var $el = $(this);

    // get video ID from URL
    var videoId = getYoutubeVideoId($el.attr('href'));

    var args = $.extend({}, videoOptions, {
      videoId: videoId
    });

    // Disable plays inline on mobile
    args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;

    var videoModalPlayer = new YT.Player('VideoHolder', args);
    modal.open();

    $('body').on('modalClose.VideoModal', function() {
      // Slight timeout so it is destroyed after the modal closes
      setTimeout(function() {
        videoModalPlayer.destroy();
      }, 500); // modal close css transition
    });
  }

  function getYoutubeVideoId(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  }
};



theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submitted
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


theme.Product = (function() {
  var youtubeReady;
  var videos = {};
  var youtubePlayers = [];
  var youtubeVideoOptions = {
    height: '480',
    width: '850',
    playerVars :{
      autohide: 0,
      autoplay: 1,
      branding: 0,
      cc_load_policy: 0,
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    },
    events: {
      onReady: onVideoPlayerReady,
      onStateChange: onVideoStateChange
    }
  };

  var vimeoReady;
  var vimeoPlayers = [];
  var vimeoVideoOptions = {
    byline: false,
    title: false,
    portrait: false,
    loop: true
  };

  var selectors = {
    videoParent: '.product__video-wrapper'
  };

  var classes = {
    loading: 'loading',
    loaded: 'loaded',
    currentSlide: 'slick-current',
    productVideo: 'product__video',
    zoomInit: 'photo-zoom-init'
  };

  function onVideoPlayerReady(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    youtubePlayers[playerId] = evt.target; // update stored player
    var player = youtubePlayers[playerId];

    setParentAsLoading($player);

    if (videos[playerId].style === 'muted') {
      youtubePlayers[playerId].mute().playVideo().pauseVideo();
    } else {
      setParentAsLoaded($player);
    }

    // If first slide or only photo, start video
    if ($player.closest('.' + classes.currentSlide).length || $player.data('image-count') === 1) {
      youtubePlayers[playerId].playVideo();
      initCheckVisibility(playerId);
    }
  }

  function initCheckVisibility(playerId) {
    // Add out of view pausing
    videoVisibilityCheck(playerId);
    $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
  }

  function videoVisibilityCheck(id) {
    var playerId;

    if (typeof id === 'string') {
      playerId = id;
    } else {
      // Data comes in as part of the scroll event
      playerId = id.data.id;
    }

    if (theme.isElementVisible($('#' + playerId))) {
      playVisibleVideo(playerId);
    } else {
      pauseHiddenVideo(playerId);
    }
  }

  function playVisibleVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
      youtubePlayers[id].playVideo();
    }
  }

  function pauseHiddenVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
      youtubePlayers[id].pauseVideo();
    }
  }

  function onVideoStateChange(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    var player = youtubePlayers[playerId];

    switch (evt.data) {
      case 0: // ended
        player.playVideo();
        break;
      case 1: // playing
        setParentAsLoaded($player);
        break;
    }
  }

  function setParentAsLoading($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.loading);
  }

  function setParentAsLoaded($el) {
    $el
      .closest(selectors.videoParent)
      .removeClass(classes.loading)
      .addClass(classes.loaded);
  }

  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');

    this.inModal = $container.closest('.modal').length;
    this.$modal;

    this.settings = {
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId,
      zoom: $container.data('image-zoom') || false,
      modalInit: false,
      lazyLoadModalContent: $container.data('lazyload-content') || false,
      modalContentLoaded: false,
      slickInitialized: false,
      hasColorSwatches: false,
      hasImages: true,
      hasMultipleImages: false,
      imageSize: '620x'
    };

    // Overwrite some settings when loaded in modal
    if (this.inModal) {
      this.settings.enableHistoryState = false;
      this.settings.namespace = '.product-' + sectionId + '-modal';
      this.$modal = $('#QuickShopModal-' + sectionId);
    }

    this.classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal'
    };

    this.selectors = {
      productJson: 'ProductJson-' + sectionId,

      video: 'ProductVideo-' + sectionId,
      photoThumbs: '.product__thumb-' + sectionId,
      thumbSlider: '#ProductThumbs-' + sectionId,
      mainSlider: '#ProductPhotos-' + sectionId,
      productVideo: '.product__video',

      priceWrapper: '.product__price-wrap-' + sectionId,
      price: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      priceA11y: '#PriceA11y-' + sectionId,
      comparePriceA11y: '#ComparePriceA11y-' + sectionId,
      sku: '#Sku-' + sectionId,

      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,

      originalSelectorId: '#ProductSelect-' + sectionId,
      singleOptionSelector: '.variant__input-' + sectionId,
      variantColorLabel: '#VariantColorLabel-' + sectionId,

      formContainer: '#AddToCartForm-' + sectionId,
      bespokeRoot: '[data-bespoke-root]',
      bespokeTrigger: '[data-bespoke-trigger]',
      bespokeTriggerText: '[data-bespoke-trigger-text]',
	      bespokePanel: '[data-bespoke-panel]',
	      bespokeOptions: '[data-bespoke-options]',
	      bespokeOption: '[data-bespoke-option]',
	      bespokeOptionLabel: '.bespoke-fabric-selector__option',
	      bespokeStatus: '[data-bespoke-status]',
	      bespokeClose: '[data-bespoke-close]',
	      bespokeVisibleList: '[data-bespoke-visible-list]',
	      bespokeHistorySwatch: '[data-bespoke-memory-swatch]',
	      bespokePropertyFabric: '[data-bespoke-property-fabric]',
	      bespokePropertyEnabled: '[data-bespoke-property-enabled]',
	      bespokePropertyKey: '[data-bespoke-property-key]',
      bespokePropertyHandle: '[data-bespoke-property-handle]',
      bespokePropertyFamily: '[data-bespoke-property-family]',
      bespokeBackingInput: '[data-bespoke-backing-input]'
    };

    if (!$('#' + this.selectors.productJson).html()) {
      return;
    }

    this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);

    this.$section = $('#ProductSection-' + sectionId);
    this.$mainSlider = $(this.selectors.mainSlider);
    this.$thumbSlider = $(this.selectors.thumbSlider);
    this.$firstProductImage = this.$mainSlider.find('img').first();

    if (!this.$firstProductImage.length) {
      this.settings.hasImages = false;
    }

    this.init();
  }

  Product.prototype = $.extend({}, Product.prototype, {
    init: function() {
      this.setProductFormReady(false);

      if (this.inModal) {
        this.$container.addClass(this.classes.isModal);
        $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
        $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
      }

      this.stringOverrides();
      this.setImageSizes();
      this.initQtySelector();
      this.initAjaxProductForm();
      this.initVariants();
      this.initBespokeSelector();
      if (!this.normalizeInitialSelectionIfNeeded()) {
        this.syncSelectionState({ reason: 'init' });
      }
      this.initProductFormGuard();
      this.setProductFormReady(true);
      this.measureBespokeSwatchDimensions();
      this.initImageSwitch();

      if (!this.inModal) {
        this.checkIfVideos();
        this.createImageCarousels();
      }
    },

    stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    setProductFormReady: function(isReady) {
      if (!this.$productForm || !this.$productForm.length) {
        this.$productForm = $(this.selectors.formContainer, this.$container);
      }

      if (!this.$productForm.length) {
        return;
      }

      if (this.$productForm.attr('data-product-form-hydration-gated') !== 'true') {
        this.$productForm.attr('data-product-form-ready', 'true');
        return;
      }

      this.$productForm.attr('data-product-form-ready', isReady ? 'true' : 'false');
    },

    setImageSizes: function() {
      if (!this.settings.hasImages) {
        return;
      }

      // Get srcset image src, works on most modern browsers
      // otherwise defaults to settings.imageSize
      var currentImage = this.$firstProductImage[0].currentSrc;

      if (currentImage) {
        this.settings.imageSize = theme.Images.imageSize(currentImage);
      }

      if (this.settings.zoom) {
        this.settings.imageZoomSize = theme.Images.imageSize(this.$firstProductImage.parent().data('zoom-size'));
      }
    },

    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productObject,
        imageResolver: this.getVariantFeaturedImage.bind(this)
      };

      if ($(this.selectors.variantColorLabel).length) {
        this.settings.hasColorSwatches = true;
        this.$colorSwatchLabel = $(this.selectors.variantColorLabel);
        this.colorOptionIndex = this.$colorSwatchLabel.data('option-index');
      }

      this.variants = new slate.Variants(options);
      this.currentVariant = this.variants.currentVariant;
      if (this.currentVariant) {
        $(this.selectors.originalSelectorId, this.$container).val(this.currentVariant.id);
      }
      this.$container.on('variantChange' + this.settings.namespace, this.handleVariantChange.bind(this));
    },

    initBespokeSelector: function() {
      this.$bespokeRoot = this.$container.find(this.selectors.bespokeRoot).first();

      if (!this.$bespokeRoot.length) {
        return;
      }

	      this.bespoke = {
	        panelOpen: false,
	        selectedFabric: null,
	        selectionHistory: [],
	        lastStandardColorValue: null,
	        lastOpener: null,
	        allowedOptions: null,
	        backingValue: this.$bespokeRoot.data('bespoke-backing-value') || 'Bespoke',
	        triggerLabel: this.$bespokeRoot.data('bespoke-trigger-label') || 'More fabrics',
	        familyLabel: this.$bespokeRoot.data('bespoke-family-label') || '',
	        colorOptionIndex: this.getColorOptionIndex()
	      };

	      this.$bespokeTrigger = this.$container.find(this.selectors.bespokeTrigger).first();
	      this.$bespokeTriggerText = this.$container.find(this.selectors.bespokeTriggerText).first();
	      this.$bespokePanel = this.$bespokeRoot.find(this.selectors.bespokePanel).first();
	      this.$bespokeOptions = this.$bespokeRoot.find(this.selectors.bespokeOptions).first();
	      this.$bespokeStatus = this.$bespokeRoot.find(this.selectors.bespokeStatus).first();
	      this.$bespokeClose = this.$bespokeRoot.find(this.selectors.bespokeClose).first();
	      this.$bespokeVisibleList = this.$container.find(this.selectors.bespokeVisibleList).first();
      this.$bespokeBackingInput = this.$container.find(this.selectors.bespokeBackingInput).first();
      this.$bespokePropertyFabric = this.$bespokeRoot.find(this.selectors.bespokePropertyFabric).first();
      this.$bespokePropertyEnabled = this.$bespokeRoot.find(this.selectors.bespokePropertyEnabled).first();
      this.$bespokePropertyKey = this.$bespokeRoot.find(this.selectors.bespokePropertyKey).first();
      this.$bespokePropertyHandle = this.$bespokeRoot.find(this.selectors.bespokePropertyHandle).first();
      this.$bespokePropertyFamily = this.$bespokeRoot.find(this.selectors.bespokePropertyFamily).first();

      if (!this.$bespokeTrigger.length || !this.$bespokePanel.length || !this.$bespokeOptions.length || this.bespoke.colorOptionIndex < 0) {
        this.$bespokeRoot.attr('hidden', true);
        this.bespoke = null;
        return;
      }

	      this.bespoke.allowedOptions = this.buildAllowedBespokeOptionMap();
	      this.bespoke.selectedFabric = this.readValidatedBespokeFabricFromState(this.bespoke.allowedOptions);
	      this.rememberBespokeSelection(this.bespoke.selectedFabric, this.bespoke.allowedOptions);
	      if (!this.bespoke.selectedFabric) {
	        this.setBespokeProperties(null);
	      }

	      this.$bespokeTrigger.on('click', this.handleBespokeTriggerClick.bind(this));
	      this.$bespokeClose.on('click', this.handleBespokeCloseClick.bind(this));
	      if (this.$bespokeVisibleList.length) {
	        this.$bespokeVisibleList.on('click', this.selectors.bespokeHistorySwatch, this.handleBespokeHistorySwatchClick.bind(this));
	      }
	      this.$bespokeOptionInputs = this.$bespokeRoot.find(this.selectors.bespokeOption);
      this.$bespokeOptionInputs.on('change', this.onBespokeOptionChange.bind(this));
      this.$bespokeOptionLabels = this.$bespokeRoot.find(this.selectors.bespokeOptionLabel);
      this.$bespokeOptionLabels.on('click', this.onBespokeOptionClick.bind(this));
      this.$bespokePanel.on('keydown', this.handleBespokePanelKeydown.bind(this));
      $(document).on('mousedown' + this.settings.namespace, this.handleDocumentPointerDown.bind(this));
      $(document).on('touchstart' + this.settings.namespace, this.handleDocumentPointerDown.bind(this));
      this._measureBespokeSwatchDimensions = $.debounce(100, this.measureBespokeSwatchDimensions.bind(this));
      this._syncBespokePanelPosition = $.debounce(100, this.syncBespokePanelPosition.bind(this));
      this._syncBespokePanelScrollLimit = $.debounce(100, this.syncBespokePanelScrollLimit.bind(this));
      $(window).on('resize' + this.settings.namespace, this._measureBespokeSwatchDimensions);
      $(window).on('resize' + this.settings.namespace, this._syncBespokePanelPosition);
      $(window).on('resize' + this.settings.namespace, this._syncBespokePanelScrollLimit);

      this.measureBespokeSwatchDimensions();
    },

    // Variant change functions
	    handleVariantChange: function(evt) {
	      if (this.bespoke && this.bespoke.panelOpen && !this.isInternalBespokeColorValue(this.getSelectedColorValue())) {
	        this.bespoke.panelOpen = false;
	      }

	      this.syncSelectionState({
	        reason: 'variant-change',
	        purchaseVariant: evt && typeof evt.variant !== 'undefined' ? evt.variant : undefined
	      });
	    },

    normalizeSelectionToken: function(value) {
      if (typeof value === 'undefined' || value === null) {
        return '';
      }

      return String(value)
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    },

    getColorOptionIndex: function() {
      if (typeof this._colorOptionIndex !== 'undefined') {
        return this._colorOptionIndex;
      }

      this._colorOptionIndex = -1;

      if (typeof this.colorOptionIndex === 'number') {
        this._colorOptionIndex = this.colorOptionIndex;
        return this._colorOptionIndex;
      }

      if (!this.productObject || !this.productObject.options) {
        return this._colorOptionIndex;
      }

      for (var i = 0; i < this.productObject.options.length; i++) {
        var optionName = this.productObject.options[i];
        if (!optionName) {
          continue;
        }

        optionName = optionName.toLowerCase();

        if (optionName.indexOf('color') > -1 || optionName.indexOf('colour') > -1) {
          this._colorOptionIndex = i;
          break;
        }
      }

      return this._colorOptionIndex;
    },

    getCurrentOptionValues: function() {
      var values = [];

      $(this.selectors.singleOptionSelector, this.$container).each(function(index, element) {
        var $element = $(element);
        var type = $element.attr('type');
        var optionIndex = parseInt(($element.data('index') || '').replace('option', ''), 10) - 1;

        if (optionIndex < 0) {
          return;
        }

        if (type === 'radio' || type === 'checkbox') {
          if (!$element.prop('checked')) {
            return;
          }
        }

        values[optionIndex] = $element.val();
      });

      return values;
    },

    getCurrentSelectedVariant: function() {
      return this.getPurchaseVariantFromOptionValues(this.getCurrentOptionValues());
    },

    getPurchaseVariantFromOptionValues: function(values) {
      var variants = (this.productObject && this.productObject.variants) || [];

      for (var variantIndex = 0; variantIndex < variants.length; variantIndex++) {
        var variant = variants[variantIndex];
        var matches = true;

        for (var i = 0; i < values.length; i++) {
          if (typeof values[i] === 'undefined' || values[i] === null || values[i] === '') {
            continue;
          }

          if (!variant.options || variant.options[i] !== values[i]) {
            matches = false;
            break;
          }
        }

        if (matches) {
          return variant;
        }
      }

      return null;
    },

    getVariantFromOptionValues: function(values) {
      return this.getPurchaseVariantFromOptionValues(values);
    },

    getInternalBespokeBackingValue: function() {
      if (this.bespoke && this.bespoke.backingValue) {
        return this.bespoke.backingValue;
      }

      return 'Bespoke';
    },

    isInternalBespokeColorValue: function(value) {
      return !!value && value === this.getInternalBespokeBackingValue();
    },

    variantContainsInternalBespoke: function(variant) {
      var colorOptionIndex = this.getColorOptionIndex();

      if (!variant) {
        return false;
      }

      if (colorOptionIndex > -1 && variant.options && variant.options[colorOptionIndex]) {
        return this.isInternalBespokeColorValue(variant.options[colorOptionIndex]);
      }

      if (!variant.options || !variant.options.length) {
        return false;
      }

      for (var i = 0; i < variant.options.length; i++) {
        if (this.isInternalBespokeColorValue(variant.options[i])) {
          return true;
        }
      }

      return false;
    },

    getSelectedColorValue: function(optionValues) {
      var colorOptionIndex = this.getColorOptionIndex();
      var selectedValues = $.isArray(optionValues) ? optionValues : this.getCurrentOptionValues();

      if (colorOptionIndex < 0) {
        return null;
      }

      return selectedValues[colorOptionIndex] || null;
    },

    getVisibleColorValues: function() {
      var colorOptionIndex = this.getColorOptionIndex();
      var selector;
      var visibleValues = [];
      var seen = {};
      var backingValue = this.getInternalBespokeBackingValue();

      if (colorOptionIndex < 0) {
        return visibleValues;
      }

      selector = this.selectors.singleOptionSelector + '[data-index="option' + (colorOptionIndex + 1) + '"]';

      this.$container.find(selector).each(function() {
        var $input = $(this);

        if ($input.is('select')) {
          $input.find('option').each(function() {
            var optionValue = $.trim($(this).val() || '');

            if (!optionValue || optionValue === backingValue || seen[optionValue]) {
              return;
            }

            seen[optionValue] = true;
            visibleValues.push(optionValue);
          });

          return false;
        }

        var inputValue = $.trim($input.val() || '');

        if (!inputValue || inputValue === backingValue || $input.is('[data-bespoke-backing-input]') || seen[inputValue]) {
          return;
        }

        seen[inputValue] = true;
        visibleValues.push(inputValue);
      });

      return visibleValues;
    },

    getFirstVisibleStandardColorValue: function() {
      var visibleColors = this.getVisibleColorValues();

      if (!visibleColors.length) {
        return null;
      }

      return visibleColors[0];
    },

    getVisibleSiblingVariantForColorValue: function(optionValues, colorValue) {
      var colorOptionIndex = this.getColorOptionIndex();
      var candidateValues;
      var candidateVariant;

      if (colorOptionIndex < 0 || !$.isArray(optionValues) || !colorValue) {
        return null;
      }

      candidateValues = optionValues.slice(0);
      candidateValues[colorOptionIndex] = colorValue;
      candidateVariant = this.getPurchaseVariantFromOptionValues(candidateValues);

      if (!candidateVariant || this.variantContainsInternalBespoke(candidateVariant)) {
        return null;
      }

      return candidateVariant;
    },

    getLastValidStandardColorValue: function(optionValues, visibleColors) {
      var lastStandardColorValue;

      if (!this.bespoke) {
        return null;
      }

      lastStandardColorValue = $.trim(this.bespoke.lastStandardColorValue || '');

      if (!lastStandardColorValue || $.inArray(lastStandardColorValue, visibleColors) === -1) {
        return null;
      }

      return this.getVisibleSiblingVariantForColorValue(optionValues, lastStandardColorValue)
        ? lastStandardColorValue
        : null;
    },

    getVisibleSiblingVariant: function(optionValues) {
      var colorOptionIndex = this.getColorOptionIndex();
      var visibleColors = this.getVisibleColorValues();
      var preferredColorValue = this.getLastValidStandardColorValue(optionValues, visibleColors);
      var fallbackVariant = null;

      if (colorOptionIndex < 0 || !$.isArray(optionValues) || !visibleColors.length) {
        return null;
      }

      if (preferredColorValue) {
        return this.getVisibleSiblingVariantForColorValue(optionValues, preferredColorValue);
      }

      for (var i = 0; i < visibleColors.length; i++) {
        var candidateVariant = this.getVisibleSiblingVariantForColorValue(optionValues, visibleColors[i]);
        if (!candidateVariant) {
          continue;
        }

        if (candidateVariant.available) {
          return candidateVariant;
        }

        if (!fallbackVariant) {
          fallbackVariant = candidateVariant;
        }
      }

      return fallbackVariant;
    },

    getDisplayVariantForSelection: function(optionValues, purchaseVariant) {
      if (purchaseVariant && (!this.bespoke || !this.variantContainsInternalBespoke(purchaseVariant))) {
        return purchaseVariant;
      }

      if (!this.bespoke) {
        return purchaseVariant || null;
      }

      return this.getVisibleSiblingVariant(optionValues);
    },

    getVariantFeaturedImage: function(variant) {
      if (!variant) {
        return null;
      }

      if (variant.featured_image && variant.featured_image.src) {
        return variant.featured_image;
      }

      if (this.variantContainsInternalBespoke(variant)) {
        return null;
      }

      var colorOptionIndex = this.getColorOptionIndex();
      if (colorOptionIndex < 0 || !variant.options || !variant.options.length) {
        return null;
      }

      var colorValue = variant.options[colorOptionIndex];
      if (!colorValue || !this.productObject || !this.productObject.variants) {
        return null;
      }

      for (var i = 0; i < this.productObject.variants.length; i++) {
        var candidate = this.productObject.variants[i];
        if (!candidate || !candidate.options) {
          continue;
        }

        if (candidate.options[colorOptionIndex] === colorValue && candidate.featured_image && candidate.featured_image.src) {
          return candidate.featured_image;
        }
      }

      return null;
    },

    renderVariantImage: function(variant) {
      if (!this.settings.hasImages || !this.$mainSlider.length) {
        return;
      }

      var variantImage = this.getVariantFeaturedImage(variant);
      if (!variantImage || !variantImage.id) {
        this.resetVariantImage();
        return;
      }

      var $targetSlide = this.$mainSlider.find('.slick-slide[data-product-image-id="' + variantImage.id + '"]:not(.slick-cloned)').first();
      var imageIndex;

      if ($targetSlide.length) {
        imageIndex = parseInt($targetSlide.attr('data-slick-index'), 10);
      } else {
        $targetSlide = this.$mainSlider.find('[data-product-image-id="' + variantImage.id + '"]').first();
        imageIndex = this._slideIndex($targetSlide);
      }

      if (typeof imageIndex === 'undefined' || imageIndex === null || isNaN(imageIndex)) {
        this.resetVariantImage();
        return;
      }

      if (this.$mainSlider.hasClass('slick-initialized')) {
        this.$mainSlider.slick('slickGoTo', imageIndex);
      }
    },

    resetVariantImage: function() {
      if (!this.settings.hasImages || !this.$mainSlider.length || !this.$mainSlider.hasClass('slick-initialized')) {
        return;
      }

      this.$mainSlider.slick('slickGoTo', 0);
    },

    renderVariantPrice: function(variant) {
      if (!variant) {
        this.renderNeutralPrice();
        return;
      }

      $(this.selectors.price)
        .html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat))
        .show()
        .attr('content', variant.price / 100.00);

      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
        $(this.selectors.priceWrapper).show();
        $(this.selectors.price).addClass(this.classes.onSale);
        $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
        $(this.selectors.priceA11y).attr('aria-hidden', 'false');
      } else {
        $(this.selectors.comparePrice).empty();
        $(this.selectors.priceWrapper).hide();
        $(this.selectors.price).removeClass(this.classes.onSale);
        $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
      }

      if ($('body').hasClass('currencies-enabled')) {
        theme.currencySwitcher.ajaxrefresh();
      }
    },

    renderNeutralPrice: function() {
      $(this.selectors.comparePrice).empty();
      $(this.selectors.priceWrapper).hide();
      $(this.selectors.price).removeClass(this.classes.onSale).removeAttr('content').text(theme.strings.unavailable);
      $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
    },

    renderVariantSku: function(variant) {
      if (!$(this.selectors.sku).length) {
        return;
      }

      $(this.selectors.sku).html(variant && variant.sku ? variant.sku : '');
    },

    renderNeutralMerchandising: function() {
      this.renderNeutralPrice();
      this.renderVariantSku(null);
      this.resetVariantImage();
    },

    updateColorName: function(state) {
      if (!this.$colorSwatchLabel) {
        return;
      }

      var labelText = this.getCustomerFacingColorLabel(state);

      if (labelText) {
        this.$colorSwatchLabel.text(labelText);
      } else {
        this.$colorSwatchLabel.empty();
      }
    },

    getCustomerFacingColorLabel: function(state) {
      var colorOptionIndex = this.getColorOptionIndex();
      var selectedColorValue = state && state.optionValues ? state.optionValues[colorOptionIndex] : this.getSelectedColorValue();

      if (colorOptionIndex < 0) {
        return '';
      }

      if (state && state.isBespokeBackingSelected && state.selectedBespokeFabric && state.selectedBespokeFabric.name) {
        return state.selectedBespokeFabric.name;
      }

      if (
        state &&
        state.displayVariant &&
        state.displayVariant.options &&
        state.displayVariant.options[colorOptionIndex] &&
        !this.isInternalBespokeColorValue(state.displayVariant.options[colorOptionIndex])
      ) {
        return state.displayVariant.options[colorOptionIndex];
      }

      if (selectedColorValue && !this.isInternalBespokeColorValue(selectedColorValue)) {
        return selectedColorValue;
      }

      return this.getFirstVisibleStandardColorValue() || '';
    },

    hasBespokeCommercialMismatch: function(purchaseVariant, displayVariant) {
      if (!purchaseVariant || !displayVariant) {
        return false;
      }

      return purchaseVariant.price !== displayVariant.price ||
        purchaseVariant.compare_at_price !== displayVariant.compare_at_price;
    },

    rememberLastStandardVisibleSibling: function(state) {
      var colorOptionIndex = this.getColorOptionIndex();
      var colorValue;

      if (!this.bespoke || !state || state.state !== 'standard-valid' || !state.purchaseVariant) {
        return;
      }

      if (colorOptionIndex < 0 || !state.purchaseVariant.options || !state.purchaseVariant.options.length) {
        return;
      }

      colorValue = $.trim(state.purchaseVariant.options[colorOptionIndex] || '');

      if (!colorValue || this.isInternalBespokeColorValue(colorValue)) {
        return;
      }

      if ($.inArray(colorValue, this.getVisibleColorValues()) === -1) {
        return;
      }

      this.bespoke.lastStandardColorValue = colorValue;
    },

    getAllowedBespokeOptionRecord: function($option) {
      var key = $.trim($option.data('bespoke-key') || '');
      var name = $.trim($option.data('bespoke-name') || '');

      if (!key || !name) {
        return null;
      }

      var handle = $.trim($option.data('bespoke-handle') || '');

      return {
        id: $option.attr('id') || '',
        key: key,
        value: $.trim($option.val() || ''),
        name: name,
        nameKey: this.normalizeSelectionToken(name),
        handle: handle,
        handleKey: this.normalizeSelectionToken(handle),
        family: $.trim($option.data('bespoke-family') || '') || (this.bespoke ? this.bespoke.familyLabel : ''),
        image: $.trim($option.data('bespoke-image') || '')
      };
    },

    indexUniqueBespokeOption: function(index, ambiguousIndex, key, record) {
      if (!key) {
        return;
      }

      if (ambiguousIndex[key]) {
        return;
      }

      if (index[key]) {
        delete index[key];
        ambiguousIndex[key] = true;
        return;
      }

      index[key] = record;
    },

    buildAllowedBespokeOptionMap: function() {
      var map = {
        list: [],
        byKey: {},
        ambiguousKeys: {},
        byHandle: {},
        ambiguousHandles: {},
        byName: {},
        ambiguousNames: {}
      };

      if (!this.bespoke || !this.$bespokeRoot || !this.$bespokeRoot.length) {
        return map;
      }

      this.$bespokeRoot.find(this.selectors.bespokeOption).each(function() {
        var $option = $(this);
        var record = this.getAllowedBespokeOptionRecord($option);

        if (!record) {
          return;
        }

        map.list.push(record);
        this.indexUniqueBespokeOption(map.byKey, map.ambiguousKeys, record.key, record);
        this.indexUniqueBespokeOption(map.byHandle, map.ambiguousHandles, record.handleKey, record);
        this.indexUniqueBespokeOption(map.byName, map.ambiguousNames, record.nameKey, record);
      }.bind(this));

      return map;
    },

    getBespokePropertyState: function() {
      var isEnabled = !!(
        this.$bespokePropertyEnabled.length &&
        !this.$bespokePropertyEnabled.is(':disabled') &&
        this.$bespokePropertyEnabled.val() === 'true'
      );

      return {
        enabled: isEnabled,
        fabric: this.$bespokePropertyFabric.length ? $.trim(this.$bespokePropertyFabric.val() || '') : '',
        key: this.$bespokePropertyKey.length ? $.trim(this.$bespokePropertyKey.val() || '') : '',
        handle: this.$bespokePropertyHandle.length ? $.trim(this.$bespokePropertyHandle.val() || '') : '',
        family: this.$bespokePropertyFamily.length ? $.trim(this.$bespokePropertyFamily.val() || '') : ''
      };
    },

    bespokePropertyStateMatchesFabric: function(propertyState, fabric, options) {
      options = options || {};
      var requireExactKey = options.requireExactKey !== false;
      var requireHandle = !!options.requireHandle;

      if (!propertyState || !propertyState.enabled || !fabric || !propertyState.fabric) {
        return false;
      }

      if (propertyState.fabric !== fabric.name) {
        return false;
      }

      if (requireExactKey) {
        if (!propertyState.key || propertyState.key !== fabric.key) {
          return false;
        }
      } else if (propertyState.key && propertyState.key !== fabric.key) {
        return false;
      }

      if (requireHandle) {
        if (!propertyState.handle || propertyState.handle !== (fabric.handle || '')) {
          return false;
        }
      } else if (propertyState.handle && propertyState.handle !== (fabric.handle || '')) {
        return false;
      }

      if (propertyState.family && propertyState.family !== (fabric.family || '')) {
        return false;
      }

      return true;
    },

    readValidatedBespokeFabricFromState: function(allowedOptions) {
      var propertyState = this.getBespokePropertyState();

      if (!propertyState.enabled) {
        return null;
      }

      if (!allowedOptions) {
        return null;
      }

      if (!propertyState.fabric && !propertyState.handle && !propertyState.key) {
        return null;
      }

      if (propertyState.key) {
        var exactMatch = allowedOptions.byKey[propertyState.key];

        if (exactMatch && this.bespokePropertyStateMatchesFabric(propertyState, exactMatch, { requireExactKey: true })) {
          return exactMatch;
        }

        return null;
      }

      if (propertyState.handle) {
        var handleKey = this.normalizeSelectionToken(propertyState.handle);
        var handleMatch = handleKey ? allowedOptions.byHandle[handleKey] : null;

        if (handleMatch && this.bespokePropertyStateMatchesFabric(propertyState, handleMatch, { requireExactKey: false, requireHandle: true })) {
          return handleMatch;
        }

        return null;
      }

      var nameKey = this.normalizeSelectionToken(propertyState.fabric);
      var nameMatch = nameKey ? allowedOptions.byName[nameKey] : null;

      if (nameMatch && this.bespokePropertyStateMatchesFabric(propertyState, nameMatch, { requireExactKey: false })) {
        return nameMatch;
      }

      return null;
    },

    findBespokeOptionInput: function(fabric) {
      if (!fabric || !this.$bespokeRoot || !this.$bespokeRoot.length) {
        return $();
      }

      var $options = this.$bespokeRoot.find(this.selectors.bespokeOption);
      var recordId = $.trim(fabric.id || '');

      if (recordId) {
        var $matchingIdOption = $options.filter(function() {
          return $.trim($(this).attr('id') || '') === recordId;
        }).first();

        if ($matchingIdOption.length) {
          return $matchingIdOption;
        }
      }

      var key = $.trim(fabric.key || '');
      var name = $.trim(fabric.name || '');
      var handle = $.trim(fabric.handle || '');
      var family = $.trim(fabric.family || '');

      if (!key || !name) {
        return $();
      }

      return $options.filter(function() {
        var $option = $(this);
        var optionKey = $.trim($option.data('bespoke-key') || '');
        var optionName = $.trim($option.data('bespoke-name') || '');
        var optionHandle = $.trim($option.data('bespoke-handle') || '');
        var optionFamily = $.trim($option.data('bespoke-family') || '');

        if (optionKey !== key || optionName !== name) {
          return false;
        }

        if (handle && optionHandle !== handle) {
          return false;
        }

        if (family && optionFamily !== family) {
          return false;
        }

        return true;
      }).first();
    },

    getExactAllowedBespokeFabric: function(fabric, allowedOptions) {
      if (!fabric) {
        return null;
      }

      var $matchingOption = this.findBespokeOptionInput(fabric);
      if ($matchingOption.length) {
        return this.getAllowedBespokeOptionRecord($matchingOption);
      }

      if (!allowedOptions) {
        return null;
      }

      var key = $.trim(fabric.key || '');
      var name = $.trim(fabric.name || '');

      if (!key || !name) {
        return null;
      }

      var exactMatch = allowedOptions.byKey[key];
      if (!exactMatch || exactMatch.name !== name) {
        return null;
      }

      return exactMatch;
    },

    getCurrentValidBespokeFabric: function(allowedOptions, preferredFabric) {
      if (!this.bespoke) {
        return null;
      }

      allowedOptions = allowedOptions || this.buildAllowedBespokeOptionMap();

      var exactPreferredFabric = this.getExactAllowedBespokeFabric(preferredFabric, allowedOptions);
      if (exactPreferredFabric) {
        return exactPreferredFabric;
      }

      var storedFabric = this.readValidatedBespokeFabricFromState(allowedOptions);
      if (storedFabric) {
        return storedFabric;
      }

      return this.getExactAllowedBespokeFabric(this.bespoke.selectedFabric, allowedOptions);
    },

	    setBespokeProperties: function(fabric) {
	      var hasFabric = !!(fabric && fabric.key && fabric.name);

	      this.$bespokePropertyFabric.prop('disabled', !hasFabric).val(hasFabric ? fabric.name : '');
	      this.$bespokePropertyEnabled.prop('disabled', !hasFabric).val(hasFabric ? 'true' : '');
	      this.$bespokePropertyKey.prop('disabled', !hasFabric).val(hasFabric ? fabric.key : '');
	      this.$bespokePropertyHandle.prop('disabled', !hasFabric).val(hasFabric ? fabric.handle : '');
	      this.$bespokePropertyFamily.prop('disabled', !hasFabric).val(hasFabric ? fabric.family : '');
	    },

	    rememberBespokeSelection: function(fabric, allowedOptions) {
	      if (!this.bespoke) {
	        return [];
	      }

	      allowedOptions = allowedOptions || this.buildAllowedBespokeOptionMap();
	      var exactFabric = this.getExactAllowedBespokeFabric(fabric, allowedOptions);
	      var history = [];
	      var seenKeys = {};

	      $.each($.isArray(this.bespoke.selectionHistory) ? this.bespoke.selectionHistory : [], function(index, fabric) {
	        var exactFabric = this.getExactAllowedBespokeFabric(fabric, allowedOptions);
	        var exactKey = exactFabric ? $.trim(exactFabric.key || '') : '';

	        if (!exactFabric || !exactKey || seenKeys[exactKey]) {
	          return;
	        }

	        seenKeys[exactKey] = true;
	        history.push(exactFabric);
	      }.bind(this));

	      if (exactFabric) {
	        var fabricKey = $.trim(exactFabric.key || '');

	        if (fabricKey && !seenKeys[fabricKey]) {
	          history.push(exactFabric);
	        }
	      }

	      this.bespoke.selectionHistory = history;
	      return history;
	    },

	    getRememberedBespokeSelections: function(allowedOptions) {
	      if (!this.bespoke) {
	        return [];
	      }

	      return this.rememberBespokeSelection(null, allowedOptions);
	    },

	    syncBespokeOptionSelection: function(selectedFabric) {
	      if (!this.bespoke || !this.$bespokeRoot.length) {
	        return;
	      }

      var selectedKey = selectedFabric ? $.trim(selectedFabric.key || '') : '';
      var selectedHandleKey = selectedFabric ? this.normalizeSelectionToken(selectedFabric.handle) : '';
      var selectedNameKey = selectedFabric ? this.normalizeSelectionToken(selectedFabric.name) : '';

      this.$bespokeRoot.find(this.selectors.bespokeOption).each(function() {
        var $input = $(this);
        var record = this.getAllowedBespokeOptionRecord($input);
        var isSelected = !!(
          selectedFabric &&
          record &&
          (
            (selectedKey && record.key === selectedKey) ||
            (!selectedKey && selectedHandleKey && record.handleKey === selectedHandleKey) ||
            (!selectedHandleKey && selectedNameKey && record.nameKey === selectedNameKey)
          )
        );

        $input.prop('checked', isSelected);

        if (record && record.id) {
          this.$bespokeRoot
            .find('label[for="' + record.id + '"]')
            .toggleClass('is-selected', isSelected);
        }
      }.bind(this));
    },

    clearBespokeSelection: function(options) {
      options = options || {};

      if (!this.bespoke) {
        return;
      }

      this.bespoke.selectedFabric = null;
      this.setBespokeProperties(null);

      if (options.closePanel !== false) {
        this.bespoke.panelOpen = false;
      }

      if (options.clearCheckedInput !== false) {
        this.syncBespokeOptionSelection(null);
      }
    },

    rejectBespokeSelection: function(previousFabric, options) {
      options = options || {};

      if (!this.bespoke) {
        return false;
      }

      var allowedOptions = options.allowedOptions || this.buildAllowedBespokeOptionMap();
      var preservedFabric = this.getCurrentValidBespokeFabric(allowedOptions, previousFabric);

      this.bespoke.allowedOptions = allowedOptions;
      this.bespoke.selectedFabric = preservedFabric;
      this.bespoke.panelOpen = true;
      this.setBespokeProperties(preservedFabric);

      this.syncSelectionState({
        reason: options.reason || 'bespoke-option-invalid',
        selectedBespokeFabric: preservedFabric
      });

      if (options.message) {
        this.setBespokeStatus(options.message);
      }

      return false;
    },

    commitBespokeSelection: function(selectedFabric, options) {
      options = options || {};
      var allowedOptions = this.buildAllowedBespokeOptionMap();
      var previousFabric = this.getCurrentValidBespokeFabric(allowedOptions, options.previousFabric);
      var exactSelectedFabric = this.getExactAllowedBespokeFabric(selectedFabric, allowedOptions);

      if (!this.bespoke || !exactSelectedFabric) {
        return this.rejectBespokeSelection(previousFabric, {
          allowedOptions: allowedOptions,
          reason: options.reason || 'bespoke-option-invalid',
          message: previousFabric
            ? 'We could not switch to that bespoke fabric. Keeping the previous selection.'
            : 'We could not select that bespoke fabric. Please try another option.'
        });
      }

      if (options.opener) {
        this.bespoke.lastOpener = options.opener.jquery ? options.opener[0] : options.opener;
      }

	      if (!this.applyOptionValue(this.bespoke.colorOptionIndex, this.bespoke.backingValue, { sync: false })) {
	        return this.rejectBespokeSelection(previousFabric, {
	          allowedOptions: allowedOptions,
	          reason: 'bespoke-backing-unavailable',
	          message: previousFabric
	            ? 'We could not switch to that bespoke fabric. Keeping the previous selection.'
	            : 'That bespoke fabric is unavailable right now. Please choose another option.'
	        });
	      }

	      this.bespoke.allowedOptions = allowedOptions;
	      this.rememberBespokeSelection(exactSelectedFabric, allowedOptions);
	      this.bespoke.selectedFabric = exactSelectedFabric;
	      this.setBespokeProperties(exactSelectedFabric);
	      this.bespoke.panelOpen = false;

      this.syncSelectionState({
        reason: options.reason || 'bespoke-selection-commit',
        selectedBespokeFabric: exactSelectedFabric
      });

      if (this.variants && typeof this.variants.refresh === 'function') {
        this.variants.refresh();
      }

	      if (options.returnFocus === false) {
	        return true;
	      }

	      window.setTimeout(function() {
	        var $focusTarget = this.getVisibleBespokeFocusTarget();

	        if ($focusTarget.length) {
	          $focusTarget[0].focus();
	        }
	      }.bind(this), 0);

      return true;
    },

    computeSelectionState: function(options) {
      options = options || {};

      var optionValues = $.isArray(options.optionValues) ? options.optionValues.slice(0) : this.getCurrentOptionValues();
      var purchaseVariant = typeof options.purchaseVariant !== 'undefined'
        ? options.purchaseVariant
        : this.getPurchaseVariantFromOptionValues(optionValues);
      var allowedOptions = this.bespoke ? this.buildAllowedBespokeOptionMap() : null;
      var selectedColorValue = this.getSelectedColorValue(optionValues);
      var isBespokeBackingSelected = !!(this.bespoke && selectedColorValue === this.bespoke.backingValue);
      var selectedBespokeFabric = isBespokeBackingSelected && this.bespoke
        ? this.getCurrentValidBespokeFabric(allowedOptions, options.selectedBespokeFabric)
        : null;
      var displayVariant = this.getDisplayVariantForSelection(optionValues, purchaseVariant);
      var hasCommercialMismatch = isBespokeBackingSelected && this.hasBespokeCommercialMismatch(purchaseVariant, displayVariant);
      var stateName = 'unavailable';

      if (isBespokeBackingSelected) {
        if (!selectedBespokeFabric) {
          stateName = 'bespoke-missing-fabric';
        } else if (!purchaseVariant) {
          stateName = 'bespoke-missing-variant';
        } else if (hasCommercialMismatch) {
          stateName = 'bespoke-commercial-mismatch';
        } else if (!purchaseVariant.available) {
          stateName = 'bespoke-sold-out';
        } else {
          stateName = 'bespoke-valid';
        }
      } else if (purchaseVariant) {
        stateName = purchaseVariant.available ? 'standard-valid' : 'standard-sold-out';
      }

      return {
        optionValues: optionValues,
        purchaseVariant: purchaseVariant,
        displayVariant: displayVariant,
        commercialVariant: purchaseVariant || null,
        imageVariant: displayVariant || purchaseVariant || null,
        allowedBespokeOptions: allowedOptions,
        selectedColorValue: selectedColorValue,
        isBespokeBackingSelected: isBespokeBackingSelected,
        selectedBespokeFabric: selectedBespokeFabric,
        hasCommercialMismatch: hasCommercialMismatch,
        state: stateName
      };
    },

    syncSelectionState: function(options) {
      var state = this.computeSelectionState(options);
      this.renderSelectionState(state);
      return state;
    },

    normalizeInitialSelectionIfNeeded: function() {
      if (!this.bespoke) {
        return false;
      }

      this.bespoke.allowedOptions = this.buildAllowedBespokeOptionMap();

      var optionValues = this.getCurrentOptionValues();
      var selectedColorValue = this.getSelectedColorValue(optionValues);

      if (selectedColorValue !== this.bespoke.backingValue) {
        return false;
      }

      var selectedFabric = this.readValidatedBespokeFabricFromState(this.bespoke.allowedOptions);
      var purchaseVariant = this.getPurchaseVariantFromOptionValues(optionValues);

      if (selectedFabric && purchaseVariant) {
        this.bespoke.selectedFabric = selectedFabric;
        return false;
      }

      this.clearBespokeSelection({
        closePanel: false,
        clearCheckedInput: true
      });

      var displayVariant = this.getDisplayVariantForSelection(optionValues, purchaseVariant);
      var fallbackColorValue = displayVariant && displayVariant.options && displayVariant.options[this.bespoke.colorOptionIndex]
        ? displayVariant.options[this.bespoke.colorOptionIndex]
        : this.getFirstVisibleStandardColorValue();

      if (!fallbackColorValue || this.isInternalBespokeColorValue(fallbackColorValue)) {
        return false;
      }

      if (!this.applyOptionValue(this.bespoke.colorOptionIndex, fallbackColorValue, { sync: false })) {
        return false;
      }

      this.variants.refresh();
      return true;
    },

    syncMasterSelect: function(variant) {
      var $field = $(this.selectors.originalSelectorId, this.$container);

      if (!$field.length) {
        return;
      }

      var variantId = variant && variant.id ? String(variant.id) : '';

      if (!$field.is('select')) {
        $field.val(variantId);
        return;
      }

      $field.find('option[data-synthetic-variant-option="true"]').remove();

      if (!variantId) {
        $field.val('');
        return;
      }

      var $matchingOption = $field.find('option').filter(function() {
        return String($(this).val() || '') === variantId;
      }).first();

      if (!$matchingOption.length) {
        $matchingOption = $('<option />', {
          value: variantId,
          'data-synthetic-variant-option': 'true'
        });
        $field.append($matchingOption);
      }

      $field.val(variantId);
    },

    renderSelectionState: function(state) {
      this.selectionState = state;
      this.currentVariant = state.purchaseVariant || null;
      this.displayVariant = state.displayVariant || null;
      this.syncMasterSelect(state.purchaseVariant);
      this.rememberLastStandardVisibleSibling(state);

      if (this.bespoke) {
        this.bespoke.allowedOptions = state.allowedBespokeOptions;
        this.bespoke.selectedFabric = state.selectedBespokeFabric;

        if (state.selectedBespokeFabric) {
          this.setBespokeProperties(state.selectedBespokeFabric);
        } else {
          this.setBespokeProperties(null);
        }
      }

      this.updateColorName(state);

      if (state.commercialVariant || state.imageVariant) {
        this.renderVariantPrice(state.commercialVariant);
        this.renderVariantSku(state.commercialVariant);

        if (state.imageVariant) {
          this.renderVariantImage(state.imageVariant);
        } else {
          this.resetVariantImage();
        }
      } else {
        this.renderNeutralMerchandising();
      }

      this.renderPurchaseState(state);
      this.renderBespokeUIState(state);
    },

    renderPurchaseState: function(state) {
      if (!state) {
        return;
      }

      if (state.state === 'standard-valid' || state.state === 'bespoke-valid') {
        this.setAddToCartState(false, theme.strings.addToCart, true);
        this.setBespokeStatus('');
        return;
      }

      if (state.state === 'standard-sold-out') {
        this.setAddToCartState(true, theme.strings.soldOut, true);
        this.setBespokeStatus('');
        return;
      }

      if (state.state === 'bespoke-missing-fabric') {
        this.setAddToCartState(true, 'Select a bespoke fabric', false);
        this.setBespokeStatus('Select an exact bespoke fabric to continue.');
        return;
      }

      if (state.state === 'bespoke-missing-variant') {
        this.setAddToCartState(true, 'Unavailable in this size', false);
        this.setBespokeStatus('The selected bespoke fabric is not available in the current size.');
        return;
      }

      if (state.state === 'bespoke-commercial-mismatch') {
        this.setAddToCartState(true, theme.strings.unavailable, true);
        this.setBespokeStatus('This bespoke fabric selection cannot be added right now. Please review the selected options.');
        return;
      }

      if (state.state === 'bespoke-sold-out') {
        this.setAddToCartState(true, theme.strings.soldOut, true);
        this.setBespokeStatus('The selected bespoke fabric is sold out in the current size.');
        return;
      }

      this.setAddToCartState(true, theme.strings.unavailable, true);
      this.setBespokeStatus('');
    },

	    renderBespokeUIState: function(state) {
	      if (!this.bespoke) {
	        return;
	      }

	      var hasSelection = !!(state.selectedBespokeFabric && state.selectedBespokeFabric.name);
	      var history = this.getRememberedBespokeSelections(state.allowedBespokeOptions);
	      var isOpen = !!this.bespoke.panelOpen;
	      var openerLabel = isOpen
	        ? 'Close bespoke fabric options.'
	        : hasSelection
	          ? 'Selected bespoke fabric: ' + state.selectedBespokeFabric.name + '. Open bespoke fabric options.'
	          : 'Open bespoke fabric options.';

	      this.$bespokeRoot.toggleClass('is-open', isOpen).prop('hidden', false);

	      this.$bespokeTrigger
	        .prop('hidden', false)
	        .toggleClass('is-active', isOpen)
	        .attr('aria-expanded', isOpen ? 'true' : 'false')
	        .attr('aria-label', openerLabel);

	      if (this.$bespokeTriggerText.length) {
	        this.$bespokeTriggerText.text(this.bespoke.triggerLabel);
	      }

	      this.$bespokePanel.prop('hidden', !isOpen).attr('aria-hidden', isOpen ? 'false' : 'true');
	      this.renderBespokeHistorySwatches(state, history);
	      this.syncBespokeOptionSelection(state.selectedBespokeFabric);
	      this.syncBespokePanelPosition();
	      this.syncBespokePanelScrollLimit();
	    },

	    updateBespokeHistorySwatch: function($button, fabric, options) {
	      options = options || {};

	      if (!$button || !$button.length || !fabric || !fabric.key || !fabric.name) {
	        return $();
	      }

	      var hasImage = !!fabric.image;
	      var isSelected = !!options.isSelected;
	      var $media = $button.find('.variant__color-swatch-bespoke__media').first();
	      var $image = $media.find('.variant__color-swatch-bespoke__image').first();
	      var $placeholder = $media.find('.variant__color-swatch-bespoke__placeholder').first();

	      $button
	        .attr('data-bespoke-memory-swatch', 'true')
	        .attr('data-bespoke-key', fabric.key)
	        .attr('data-bespoke-name', fabric.name)
	        .attr('data-bespoke-handle', fabric.handle || '')
	        .attr('data-bespoke-family', fabric.family || '')
	        .attr('data-bespoke-image', fabric.image || '')
	        .attr('data-bespoke-record-id', fabric.id || '')
	        .attr('aria-label', (isSelected ? 'Selected bespoke fabric: ' : 'Select bespoke fabric: ') + fabric.name + '.')
	        .attr('aria-pressed', isSelected ? 'true' : 'false')
	        .attr('title', fabric.name)
	        .toggleClass('is-selected', isSelected);

	      if (!$media.length) {
	        $media = $('<span />', {
	          'class': 'variant__color-swatch-bespoke__media',
	          'aria-hidden': 'true'
	        }).appendTo($button.empty());
	        $image = $();
	        $placeholder = $();
	      }

	      if (hasImage) {
	        if (!$image.length) {
	          $image = $('<img />', {
	            alt: '',
	            loading: 'lazy',
	            'class': 'variant__color-swatch-bespoke__image'
	          }).appendTo($media);
	        }

	        $image.attr('src', fabric.image);

	        if ($placeholder.length) {
	          $placeholder.remove();
	        }
	      } else {
	        if ($image.length) {
	          $image.remove();
	        }

	        if (!$placeholder.length) {
	          $placeholder = $('<span />', {
	            'class': 'variant__color-swatch-bespoke__placeholder'
	          }).appendTo($media);
	        }
	      }

	      return $button;
	    },

		    buildBespokeHistorySwatch: function(fabric, options) {
		      if (!fabric || !fabric.key || !fabric.name) {
		        return $();
		      }

		      return this.updateBespokeHistorySwatch($('<button />', {
		        type: 'button',
		        'class': 'variant__color-swatch variant__color-swatch--bespoke-memory'
		      }), fabric, options);
		    },

	    renderBespokeHistorySwatches: function(state, history) {
	      if (!this.$bespokeVisibleList.length) {
	        return;
	      }

	      history = $.isArray(history) ? history : [];
	      var selectedKey = state && state.selectedBespokeFabric ? $.trim(state.selectedBespokeFabric.key || '') : '';
	      var showHistory = !!history.length;
	      var existingByKey = {};
	      var desiredKeys = [];
	      var currentKeys = [];
	      var needsReorder = false;
	      var orderedSwatches = [];

	      this.$bespokeVisibleList
	        .children(this.selectors.bespokeHistorySwatch)
	        .each(function() {
	          var $swatch = $(this);
	          var key = $.trim($swatch.data('bespokeKey') || '');

	          if (!key) {
	            $swatch.remove();
	            return;
	          }

	          currentKeys.push(key);
	          existingByKey[key] = $swatch;
	        });

	      this.$bespokeVisibleList.prop('hidden', !showHistory);

	      if (!showHistory) {
	        return;
	      }

	      $.each(history, function(index, fabric) {
	        var key = $.trim(fabric.key || '');
	        var $swatch = key && existingByKey[key]
	          ? existingByKey[key]
	          : this.buildBespokeHistorySwatch(fabric, {
	            isSelected: !!(selectedKey && key === selectedKey)
	          });

	        this.updateBespokeHistorySwatch($swatch, fabric, {
	          isSelected: !!(selectedKey && key === selectedKey)
	        });

	        desiredKeys.push(key);
	        orderedSwatches.push($swatch);
	        delete existingByKey[key];
	      }.bind(this));

	      $.each(existingByKey, function(key, $swatch) {
	        $swatch.remove();
	      });

	      needsReorder = currentKeys.length !== desiredKeys.length;

	      if (!needsReorder) {
	        needsReorder = $.grep(desiredKeys, function(key, index) {
	          return currentKeys[index] !== key;
	        }).length > 0;
	      }

	      if (!needsReorder) {
	        return;
	      }

		      $.each(orderedSwatches, function(index, $swatch) {
		        this.$bespokeVisibleList.append($swatch);
		      }.bind(this));
		    },

	    getVisibleActiveBespokeHistorySwatch: function() {
	      if (!this.$bespokeVisibleList.length || this.$bespokeVisibleList.prop('hidden')) {
	        return $();
	      }

	      return this.$bespokeVisibleList.find(this.selectors.bespokeHistorySwatch).filter(function() {
	        return $(this).hasClass('is-selected') && document.body.contains(this) && !$(this).prop('hidden');
	      }).first();
	    },

	    getVisibleBespokeFocusTarget: function() {
	      var $activeHistorySwatch = this.getVisibleActiveBespokeHistorySwatch();
	      if ($activeHistorySwatch.length) {
	        return $activeHistorySwatch;
	      }

	      if (
	        this.$bespokeTrigger.length &&
	        document.body.contains(this.$bespokeTrigger[0]) &&
	        !this.$bespokeTrigger.prop('hidden')
	      ) {
	        return this.$bespokeTrigger.first();
	      }

	      return $();
	    },

		    applyOptionValue: function(optionIndex, value, options) {
		      options = options || {};

      var selector = '[data-index="option' + (optionIndex + 1) + '"]';
      var $inputs = this.$container.find(selector);
      var didSet = false;

      $inputs.each(function() {
        var $input = $(this);

        if ($input.is('select')) {
          if ($input.find('option').filter(function() { return $(this).val() === value; }).length) {
            $input.val(value);
            didSet = $input.val() === value;
          }

          return false;
        }

        if ($input.val() !== value) {
          return;
        }

        $inputs.not($input).filter(':radio').prop('checked', false);
        $input.prop('checked', true);
        didSet = true;
        return false;
      });

      if (didSet && options.sync !== false && this.variants && typeof this.variants.refresh === 'function') {
        this.variants.refresh();
      }

      return didSet;
    },

    setOptionValue: function(optionIndex, value, options) {
      return this.applyOptionValue(optionIndex, value, options);
    },

    handleBespokeTriggerClick: function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if (!this.bespoke) {
        return;
      }

      if (this.bespoke.panelOpen) {
        this.closeBespokePanel({ opener: evt.currentTarget, returnFocus: false });
      } else {
        this.openBespokePanel(evt.currentTarget);
      }
    },

	    handleBespokeCloseClick: function(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      this.closeBespokePanel();
	    },

		    handleBespokeHistorySwatchClick: function(evt) {
		      evt.preventDefault();
	      evt.stopPropagation();

	      if (!this.bespoke) {
	        return;
	      }

	      var $swatch = $(evt.currentTarget);
	      var allowedOptions = this.buildAllowedBespokeOptionMap();
	      var previousFabric = this.getCurrentValidBespokeFabric(allowedOptions);
	      var selectedFabric = {
	        id: $.trim($swatch.data('bespokeRecordId') || ''),
	        key: $.trim($swatch.data('bespokeKey') || ''),
	        name: $.trim($swatch.data('bespokeName') || ''),
	        handle: $.trim($swatch.data('bespokeHandle') || ''),
	        family: $.trim($swatch.data('bespokeFamily') || ''),
	        image: $.trim($swatch.data('bespokeImage') || '')
	      };

	      this.commitBespokeSelection(selectedFabric, {
	        allowedOptions: allowedOptions,
	        previousFabric: previousFabric,
	        opener: evt.currentTarget,
	        reason: 'bespoke-history-swatch'
	      });
	    },

	    onBespokeOptionChange: function(evt) {
	      evt.stopPropagation();

      if (!this.bespoke) {
        return;
      }

      var inputElement = evt.currentTarget;

      if (!inputElement || !$(inputElement).is(this.selectors.bespokeOption)) {
        inputElement = evt.target;
      }

      var $input = $(inputElement);
      if (!$input.is(':checked')) {
        return;
      }

      var allowedOptions = this.buildAllowedBespokeOptionMap();
      var previousFabric = this.getCurrentValidBespokeFabric(allowedOptions);
      var selectedFabric = this.getAllowedBespokeOptionRecord($input);

	      this.commitBespokeSelection(selectedFabric, {
	        allowedOptions: allowedOptions,
	        previousFabric: previousFabric,
	        opener: this.bespoke.lastOpener || (this.$bespokeTrigger.length ? this.$bespokeTrigger[0] : null),
	        reason: 'bespoke-option-change'
	      });
	    },

    onBespokeOptionClick: function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if (!this.bespoke) {
        return;
      }

      var $label = $(evt.currentTarget);
      var optionId = $.trim($label.attr('for') || '');
      var $input = optionId
        ? this.$bespokeRoot.find(this.selectors.bespokeOption).filter(function() {
            return $.trim($(this).attr('id') || '') === optionId;
          }).first()
        : $label.closest('.bespoke-fabric-selector__choice').find(this.selectors.bespokeOption).first();

      if (!$input.length) {
        return;
      }

      this.$bespokeRoot.find(this.selectors.bespokeOption).not($input).prop('checked', false);
      $input.prop('checked', true).trigger('change');
    },

    openBespokePanel: function(opener) {
      if (!this.bespoke) {
        return;
      }

      this.bespoke.lastOpener = opener && opener.jquery ? opener[0] : opener || this.$bespokeTrigger[0] || null;
      this.bespoke.panelOpen = true;
      this.syncSelectionState({ reason: 'bespoke-panel-open' });
      this.focusBespokePanelInitialControl();
    },

    closeBespokePanel: function(options) {
      options = options || {};

      if (!this.bespoke) {
        return;
      }

      if (options.opener) {
        this.bespoke.lastOpener = options.opener.jquery ? options.opener[0] : options.opener;
      }

      this.bespoke.panelOpen = false;
      this.syncSelectionState({ reason: 'bespoke-panel-close' });

      if (options.returnFocus === false) {
        return;
      }

	      var opener = this.bespoke.lastOpener || null;
	      if ((!opener || !document.body.contains(opener) || $(opener).prop('hidden')) && this.$bespokeTrigger.length) {
	        opener = this.$bespokeTrigger[0];
	      }
	      if (opener && document.body.contains(opener) && !$(opener).prop('hidden')) {
	        opener.focus();
	      }
    },

    focusBespokePanelInitialControl: function() {
      if (!this.bespoke || !this.bespoke.panelOpen) {
        return;
      }

      var $focusTarget = $();

      if (this.bespoke.selectedFabric && this.bespoke.selectedFabric.name) {
        var selectedKey = $.trim(this.bespoke.selectedFabric.key || '');
        var selectedHandleKey = this.normalizeSelectionToken(this.bespoke.selectedFabric.handle);
        var selectedNameKey = this.normalizeSelectionToken(this.bespoke.selectedFabric.name);

        $focusTarget = this.$bespokeRoot.find(this.selectors.bespokeOption).filter(function() {
          var $option = $(this);
          return (
            (selectedKey && $.trim($option.data('bespoke-key') || '') === selectedKey) ||
            (!selectedKey && selectedHandleKey && this.normalizeSelectionToken($option.data('bespoke-handle')) === selectedHandleKey) ||
            (!selectedHandleKey && selectedNameKey && this.normalizeSelectionToken($option.data('bespoke-name')) === selectedNameKey)
          );
        }.bind(this)).first();
      }

      if (!$focusTarget.length) {
        $focusTarget = this.$bespokeRoot.find(this.selectors.bespokeOption).first();
      }

      if (!$focusTarget.length && this.$bespokeClose.length) {
        $focusTarget = this.$bespokeClose;
      }

      if (!$focusTarget.length) {
        $focusTarget = this.$bespokePanel;
      }

      window.setTimeout(function() {
        if (!this.bespoke || !this.bespoke.panelOpen || !$focusTarget.length) {
          return;
        }

        $focusTarget[0].focus();
      }.bind(this), 0);
    },

    handleDocumentPointerDown: function(evt) {
      if (!this.bespoke || !this.bespoke.panelOpen) {
        return;
      }

      var $hostWrapper = this.$bespokeRoot.closest('.variant-wrapper--bespoke-host');
      if ($hostWrapper.length && $(evt.target).closest('.variant-wrapper--bespoke-host')[0] === $hostWrapper[0]) {
        return;
      }

      this.closeBespokePanel({ returnFocus: false });
    },

    handleBespokePanelKeydown: function(evt) {
      if (evt.key !== 'Escape') {
        return;
      }

      evt.preventDefault();
      this.closeBespokePanel();
    },

    measureBespokeSwatchDimensions: function() {
      if (!this.$bespokeRoot || !this.$bespokeRoot.length || !this.$bespokeTrigger.length) {
        return;
      }

      var $hostRow = this.$bespokeTrigger.closest('.variant-input-wrap');
	      var $nativeSwatch = $hostRow.find('label.variant__color-swatch').not('.variant__color-swatch--bespoke-trigger, .variant__color-swatch--bespoke-memory').first();

	      if (!$nativeSwatch.length) {
	        return;
	      }

	      var nativeSwatch = $nativeSwatch[0];
	      if (!nativeSwatch.offsetWidth || !nativeSwatch.offsetHeight) {
	        return;
	      }

	      var computedStyle = window.getComputedStyle(nativeSwatch);
	      var triggerSize = Math.min(nativeSwatch.offsetWidth, nativeSwatch.offsetHeight) + 'px';
      var swatchStyles = {
        width: nativeSwatch.offsetWidth + 'px',
        height: nativeSwatch.offsetHeight + 'px',
        marginRight: computedStyle.marginRight,
        marginBottom: computedStyle.marginBottom,
        triggerSize: triggerSize
      };

	      this.$bespokeRoot[0].style.setProperty('--bespoke-swatch-width', swatchStyles.width);
	      this.$bespokeRoot[0].style.setProperty('--bespoke-swatch-height', swatchStyles.height);
	      this.$bespokeRoot[0].style.setProperty('--bespoke-swatch-margin-right', swatchStyles.marginRight);
	      this.$bespokeRoot[0].style.setProperty('--bespoke-swatch-margin-bottom', swatchStyles.marginBottom);
	      $hostRow[0].style.setProperty('--bespoke-swatch-width', swatchStyles.width);
	      $hostRow[0].style.setProperty('--bespoke-swatch-height', swatchStyles.height);
	      $hostRow[0].style.setProperty('--bespoke-swatch-margin-right', swatchStyles.marginRight);
	      $hostRow[0].style.setProperty('--bespoke-swatch-margin-bottom', swatchStyles.marginBottom);
	      $hostRow[0].style.setProperty('--bespoke-trigger-size', swatchStyles.triggerSize);

	      this.$bespokeTrigger[0].style.setProperty('--bespoke-swatch-width', swatchStyles.width);
	      this.$bespokeTrigger[0].style.setProperty('--bespoke-swatch-height', swatchStyles.height);
	      this.$bespokeTrigger[0].style.setProperty('--bespoke-swatch-margin-right', swatchStyles.marginRight);
	      this.$bespokeTrigger[0].style.setProperty('--bespoke-swatch-margin-bottom', swatchStyles.marginBottom);
	      this.$bespokeTrigger[0].style.setProperty('--bespoke-trigger-size', swatchStyles.triggerSize);

	      if (this.$bespokeVisibleList.length) {
	        this.$bespokeVisibleList[0].style.setProperty('--bespoke-swatch-width', swatchStyles.width);
	        this.$bespokeVisibleList[0].style.setProperty('--bespoke-swatch-height', swatchStyles.height);
	        this.$bespokeVisibleList[0].style.setProperty('--bespoke-swatch-margin-right', swatchStyles.marginRight);
	        this.$bespokeVisibleList[0].style.setProperty('--bespoke-swatch-margin-bottom', swatchStyles.marginBottom);
	      }
	    },

    syncBespokePanelScrollLimit: function() {
      if (!this.$bespokeRoot || !this.$bespokeRoot.length || !this.$bespokePanel.length || !this.$bespokeOptions.length) {
        return;
      }

      var bespokeRoot = this.$bespokeRoot[0];
      bespokeRoot.style.removeProperty('--bespoke-panel-max-height');
      bespokeRoot.style.removeProperty('--bespoke-options-max-height');
      this.$bespokePanel.removeClass('is-scroll-constrained');

      if (window.matchMedia('(max-width: 749px)').matches || !this.bespoke || !this.bespoke.panelOpen) {
        return;
      }

      var mediaColumn = this.$mainSlider && this.$mainSlider.length ? this.$mainSlider.closest('.grid__item')[0] : null;
      if (!mediaColumn) {
        return;
      }

      var mediaRect = mediaColumn.getBoundingClientRect();
      var panelRect = this.$bespokePanel[0].getBoundingClientRect();
      var headerHeight = this.$bespokePanel.find('.bespoke-fabric-selector__header').outerHeight(true) || 0;
      var viewportBottom = window.innerHeight - 24;
      var mediaBottom = mediaRect.bottom - 16;
      var maxDesktopPanelHeight = Math.floor(window.innerHeight * 0.7);
      var availablePanelHeight = Math.floor(Math.min(viewportBottom, mediaBottom) - panelRect.top);
      availablePanelHeight = Math.min(availablePanelHeight, maxDesktopPanelHeight);

      if (availablePanelHeight <= 140) {
        return;
      }

      var availableOptionsHeight = Math.floor(availablePanelHeight - headerHeight - 24);
      if (availableOptionsHeight <= 80) {
        return;
      }

      bespokeRoot.style.setProperty('--bespoke-panel-max-height', availablePanelHeight + 'px');

      if (this.$bespokeOptions[0].scrollHeight > availableOptionsHeight) {
        bespokeRoot.style.setProperty('--bespoke-options-max-height', availableOptionsHeight + 'px');
        this.$bespokePanel.addClass('is-scroll-constrained');
      }
    },

    syncBespokePanelPosition: function() {
      if (!this.$bespokeRoot || !this.$bespokeRoot.length || !this.$bespokePanel.length || !this.bespoke || !this.$bespokeTrigger.length) {
        return;
      }

      var bespokeRoot = this.$bespokeRoot[0];
      bespokeRoot.style.removeProperty('--bespoke-panel-top');
      bespokeRoot.style.removeProperty('--bespoke-panel-left');
      bespokeRoot.style.removeProperty('--bespoke-panel-width');

      if (window.matchMedia('(max-width: 749px)').matches) {
        return;
      }

      var $metaColumn = this.$section.find('.product-single__meta').first();
      var $fieldWrap = this.$bespokeTrigger.closest('.variant-input-wrap');
      if (!$metaColumn.length || !$fieldWrap.length) {
        return;
      }

      var metaRect = $metaColumn[0].getBoundingClientRect();
      var fieldRect = $fieldWrap[0].getBoundingClientRect();
      var metaStyles = window.getComputedStyle($metaColumn[0]);
      var metaPaddingLeft = parseFloat(metaStyles.paddingLeft) || 0;
      var metaPaddingRight = parseFloat(metaStyles.paddingRight) || 0;
      var viewportGutter = 12;
      var panelTop = Math.round(fieldRect.bottom - metaRect.top + 8);
      var panelLeft = Math.round(metaPaddingLeft);
      var panelWidth = Math.round($metaColumn[0].clientWidth - metaPaddingLeft - metaPaddingRight);

      if (panelWidth <= 0) {
        return;
      }

      var maxPanelWidth = Math.max(0, Math.floor(window.innerWidth - (viewportGutter * 2)));
      if (maxPanelWidth > 0) {
        panelWidth = Math.min(panelWidth, maxPanelWidth);
      }

      var desiredPanelLeft = Math.round(metaRect.left + panelLeft);
      var minPanelLeft = viewportGutter;
      var maxPanelLeft = Math.max(minPanelLeft, Math.round(window.innerWidth - viewportGutter - panelWidth));
      var clampedPanelLeft = Math.min(Math.max(desiredPanelLeft, minPanelLeft), maxPanelLeft);
      panelLeft = Math.round(clampedPanelLeft - metaRect.left);

      bespokeRoot.style.setProperty('--bespoke-panel-top', panelTop + 'px');
      bespokeRoot.style.setProperty('--bespoke-panel-left', panelLeft + 'px');
      bespokeRoot.style.setProperty('--bespoke-panel-width', panelWidth + 'px');
    },

    setAddToCartState: function(disabled, buttonText, useHtml) {
      var $button = $(this.selectors.addToCart);
      var $buttonText = $(this.selectors.addToCartText);

      if (!$button.length || !$buttonText.length) {
        return;
      }

      $button.toggleClass(this.classes.disabled, !!disabled).prop('disabled', !!disabled);
      $button.attr('aria-disabled', disabled ? 'true' : 'false');

      if (useHtml) {
        $buttonText.html(buttonText);
        return;
      }

      $buttonText.text(buttonText);
    },

    setBespokeStatus: function(message) {
      if (!this.$bespokeStatus.length) {
        return;
      }

      var hasMessage = !!message;
      this.$bespokeStatus.prop('hidden', !hasMessage).text(hasMessage ? message : '');
    },

    getSubmittedVariantId: function() {
      var $variantField = $(this.selectors.originalSelectorId, this.$container);
      return $variantField.length ? $.trim($variantField.val() || '') : '';
    },

    getBespokeSubmissionMessage: function(state, reason) {
      if (reason === 'bespoke-missing-fabric' || reason === 'bespoke-property-desync') {
        return 'Select an exact bespoke fabric before adding to cart.';
      }

      if (reason === 'bespoke-missing-variant') {
        return 'The selected bespoke fabric is not available in the current size.';
      }

      if (reason === 'bespoke-sold-out') {
        return 'The selected bespoke fabric is sold out in the current size.';
      }

      if (reason === 'bespoke-commercial-mismatch') {
        return 'This bespoke fabric selection cannot be added right now. Please review the selected options.';
      }

      if (reason === 'bespoke-variant-desync') {
        return 'Please review the bespoke selection before adding to cart.';
      }

      if (reason === 'stale-bespoke-properties') {
        return 'Please review the bespoke selection before adding to cart.';
      }

      if (state && state.state === 'bespoke-missing-fabric') {
        return 'Select an exact bespoke fabric before adding to cart.';
      }

      if (state && state.state === 'bespoke-missing-variant') {
        return 'The selected bespoke fabric is not available in the current size.';
      }

      if (state && state.state === 'bespoke-sold-out') {
        return 'The selected bespoke fabric is sold out in the current size.';
      }

      if (state && state.state === 'bespoke-commercial-mismatch') {
        return 'This bespoke fabric selection cannot be added right now. Please review the selected options.';
      }

      return 'Please review the bespoke selection before adding to cart.';
    },

    recoverInvalidBespokeSubmission: function(state, reason) {
      if (!this.bespoke) {
        return;
      }

      if (state && state.isBespokeBackingSelected && (reason === 'bespoke-missing-fabric' || reason === 'bespoke-property-desync')) {
        this.openBespokePanel(this.$bespokeTrigger.length ? this.$bespokeTrigger[0] : null);
        return;
      }

      if (this.$bespokeStatus.length && !this.$bespokeStatus.prop('hidden')) {
        this.$bespokeStatus.attr('tabindex', '-1');
        this.$bespokeStatus[0].focus();
        return;
      }

	      var $focusTarget = this.getVisibleBespokeFocusTarget();

	      if ($focusTarget.length && !$focusTarget.prop('hidden')) {
	        $focusTarget[0].focus();
      }
    },

    validateProductFormSubmission: function(options) {
      options = options || {};

      if (!this.$productForm || !this.$productForm.length) {
        return {
          valid: true,
          state: this.selectionState || this.computeSelectionState(),
          message: ''
        };
      }

      var state = this.computeSelectionState();
      var propertyState = this.bespoke ? this.getBespokePropertyState() : null;
      var submittedVariantId = this.getSubmittedVariantId();
      var reason = null;

      if (this.bespoke && state.isBespokeBackingSelected) {
        if (!state.selectedBespokeFabric) {
          reason = 'bespoke-missing-fabric';
        } else if (!this.bespokePropertyStateMatchesFabric(propertyState, state.selectedBespokeFabric, {
          requireExactKey: true,
          requireHandle: !!state.selectedBespokeFabric.handle
        })) {
          reason = 'bespoke-property-desync';
        } else if (!state.purchaseVariant) {
          reason = 'bespoke-missing-variant';
        } else if (state.hasCommercialMismatch) {
          reason = 'bespoke-commercial-mismatch';
        } else if (!submittedVariantId || String(state.purchaseVariant.id) !== submittedVariantId) {
          reason = 'bespoke-variant-desync';
        } else if (!state.purchaseVariant.available) {
          reason = 'bespoke-sold-out';
        }
      } else if (this.bespoke && propertyState && propertyState.enabled) {
        reason = 'stale-bespoke-properties';
      }

      if (!reason) {
        if (options.sync !== false) {
          state = this.syncSelectionState({
            reason: options.reason || 'product-form-submit-validated',
            optionValues: state.optionValues,
            purchaseVariant: state.purchaseVariant
          });
        }

        return {
          valid: true,
          state: state,
          message: ''
        };
      }

      state = this.syncSelectionState({
        reason: options.reason || reason,
        optionValues: state.optionValues,
        purchaseVariant: state.purchaseVariant
      });

      if (options.focusOnError !== false) {
        this.recoverInvalidBespokeSubmission(state, reason);
      }

      return {
        valid: false,
        state: state,
        reason: reason,
        message: this.getBespokeSubmissionMessage(state, reason)
      };
    },

    // Image/thumbnail toggling
    initImageSwitch: function() {
      if (!$(this.selectors.photoThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.photoThumbs).on('click', function(evt) {
        evt.preventDefault();
      });
    },

    checkIfVideos: function() {
      var $productVideos = this.$mainSlider.find(this.selectors.productVideo);

      // Stop if there are 0 videos
      if (!$productVideos.length) {
        return false;
      }

      var videoTypes = [];

      $productVideos.each(function() {
        var type = $(this).data('video-type');

        if (videoTypes.indexOf(type) < 0) {
          videoTypes.push(type);
        }
      });

      // Load YouTube API if not already loaded
      if (videoTypes.indexOf('youtube') > -1) {
        if (!theme.config.youTubeReady) {
          window.loadYouTube();
          $('body').on('youTubeReady' + this.settings.namespace, function() {
            this.loadYoutubeVideos($productVideos);
          }.bind(this));
        } else {
          this.loadYoutubeVideos($productVideos);
        }
      }

      // Load Vimeo API if not already loaded
      if (videoTypes.indexOf('vimeo') > -1) {
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.settings.namespace, function() {
            this.loadVimeoVideos($productVideos);
          }.bind(this))
        } else {
          this.loadVimeoVideos($productVideos);
        }
      }

      // Add mp4 video players
      if (videoTypes.indexOf('mp4') > -1) {
        this.loadMp4Videos($productVideos);
      }

      return videoTypes;
    },

    loadMp4Videos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'mp4') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('video-id');

        videos[this.id] = {
          type: 'mp4',
          divId: id,
          style: $el.data('video-style')
        };
      });
    },

    loadVimeoVideos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'vimeo') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('video-id');

        videos[this.id] = {
          type: 'vimeo',
          divId: id,
          id: videoId,
          style: $el.data('video-style'),
          width: $el.data('video-width'),
          height: $el.data('video-height')
        };
      });

      // Create a new player for each Vimeo video
      for (var key in videos) {
        if (videos[key].type != 'vimeo') {
          continue;
        }

        var args = $.extend({}, vimeoVideoOptions, videos[key]);
        vimeoPlayers[key] = new Vimeo.Player(videos[key].divId, args);
      }

      vimeoReady = true;
    },

    autoplayVimeoVideo: function(id) {
      // Do not autoplay on mobile though
      if (!theme.config.bpSmall) {
        this.requestToPlayVimeoVideo(id);
      } else {
        // Set as loaded on mobile so you can see the image
        var $player = $('#' + id);
        setParentAsLoaded($player);
      }
    },

    requestToPlayVimeoVideo: function(id) {
      // The slider may initialize and attempt to play the video before
      // the API is even ready, because it sucks.

      var $player = $('#' + id);
      setParentAsLoading($player);

      if (!vimeoReady) {
        // Wait for the trigger, then play it
        $('body').on('vimeoReady' + this.settings.namespace, function() {
          this.playVimeoVideo(id);
        }.bind(this))
        return;
      }

      this.playVimeoVideo(id);
    },

    playVimeoVideo: function(id) {
      vimeoPlayers[id].play();

      if (videos[id].style === 'muted') {
        vimeoPlayers[id].setVolume(0);
      }

      var $player = $('#' + id);
      setParentAsLoaded($player);
    },

    stopVimeoVideo: function(id) {
      if (!theme.config.vimeoReady) {
        return;
      }

      if (id) {
        vimeoPlayers[id].pause();
      } else {
        for (key in vimeoPlayers) {
          if (typeof vimeoPlayers[key].pause === 'function') {
            vimeoPlayers[key].pause();
          }
        }
      }
    },

    loadYoutubeVideos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'youtube') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('youtube-id');

        videos[this.id] = {
          type: 'youtube',
          id: id,
          videoId: videoId,
          style: $el.data('video-style'),
          width: $el.data('video-width'),
          height: $el.data('video-height')
        };
      });

      // Create a player for each YouTube video
      for (var key in videos) {
        if (videos[key].type === 'youtube') {
          if (videos.hasOwnProperty(key)) {
            var args = $.extend({}, youtubeVideoOptions, videos[key]);

            if (args.style === 'muted') {
              // default youtubeVideoOptions, no need to change anything
            } else {
              args.playerVars.controls = 1;
              args.playerVars.autoplay = 0;
            }

            youtubePlayers[key] = new YT.Player(key, args);
          }
        }
      }

      youtubeReady = true;
    },

    requestToPlayYoutubeVideo: function(id, forcePlay) {
      if (!theme.config.youTubeReady) {
        return;
      }

      var $player = $('#' + id);
      setParentAsLoading($player);

      // If video is requested too soon, player might not be ready.
      // Set arbitrary timeout to request it again in a second
      if (typeof youtubePlayers[id].playVideo != 'function') {
        var o = this;
        setTimeout(function() {
          o.playYoutubeVideo(id, forcePlay);
        }, 1000);
        return;
      }

      this.playYoutubeVideo(id, forcePlay);
    },

    playYoutubeVideo: function (id, forcePlay) {
      var $player = $('#' + id);
      setParentAsLoaded($player);
      youtubePlayers[id].playVideo();

      // forcePlay is sent as true from beforeSlideChange so the visibility
      // check isn't fooled by the next slide positioning
      if (!forcePlay) {
        initCheckVisibility(id);
      }
    },

    stopYoutubeVideo: function(id) {
      if (!theme.config.youTubeReady) {
        return;
      }

      if (id && youtubePlayers[id]) {
        youtubePlayers[id].pauseVideo();
        $(window).off('scroll.' + id);
      } else {
        for (key in youtubePlayers) {
          if (typeof youtubePlayers[key].pauseVideo === 'function') {
            youtubePlayers[key].pauseVideo();
            $(window).off('scroll.' + key);
          }
        }
      }
    },

    playMp4Video: function(id) {
      var $player = $('#' + id);
      setParentAsLoaded($player);

      $player[0].play();
    },

    stopMp4Video: function(id) {
      if (id) {
        $('#' + id)[0].pause();
      } else {
        // loop through all mp4 videos to stop them
        for (var key in videos) {
          if (videos[key].type === 'mp4') {
            var player = $('#' + videos[key].divId)[0];
            if (typeof player.pause === 'function') {
              player.pause();
            }
          }
        }
      }
    },

    // Init zoom for each image in the main carousel
    initZoom: function($image) {
      var largeImage = $image.parent().data('zoom-size');
      $image.parent()
      .on('click', function(evt) {
        evt.preventDefault();
      })
      .zoom({
        on: 'click',
        url: largeImage,
        duration: 180,
        touch: false,
        onZoomIn: function() {
          $(this).addClass('photo-zoom-linked');
        },
        onZoomOut: function() {
          $(this).removeClass('photo-zoom-linked');
        }
      });
    },

    createImageCarousels: function() {
      // Init zoom on non-lazy loaded image
      if (this.settings.zoom) {
        this.initZoom($('.photo-zoom-link__initial'));
      }

      var hasThumbSlider = this.$thumbSlider.length && $(this.selectors.photoThumbs).length > 1;
      var mainSlideCount = this.$mainSlider.children().length;
      var enablePrimaryImageCarousel = $('body').hasClass('template-product');

      if (!hasThumbSlider && (!enablePrimaryImageCarousel || mainSlideCount < 2)) {
        // Single product image. Init video if it exists
        var $video = this.$mainSlider.find('.product__video');
        if ($video.length) {
          this.initVideo($video);
        }
        return;
      }

      this.settings.hasMultipleImages = true;

      // Set starting slide (for both sliders)
      var $activeSlide = this.$mainSlider.find('.starting-slide');
      var startIndex = $activeSlide.length ? this._slideIndex($activeSlide) : 0;
      if (typeof startIndex === 'undefined') {
        startIndex = 0;
      }

      // Lame way to prevent duplicate event listeners
      this.$mainSlider.off('init');
      this.$mainSlider.off('beforeChange');
      this.$mainSlider.on('init', this.mainSlideInit.bind(this));
      this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
      
      window.thumbSlider = this.selectors.thumbSlider;
      window.mainSlider = this.selectors.mainSlider;
      
      
      window.mainSliderSettings = function()
      {
        var settings = {
          infinite: false,
          arrows: false,
          dots: false,
          initialSlide: startIndex
        };

        if (!hasThumbSlider && enablePrimaryImageCarousel) {
          settings.infinite = true;
          settings.arrows = true;
          settings.dots = true;
        }

        return settings;
      }
      this.$mainSlider.slick(window.mainSliderSettings());


      if (hasThumbSlider) {
        window.thumbSliderSettings = function(){
         return {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: true,
            verticalSwiping: true,
            focusOnSelect: true,
            infinite: false,
            customHeightMatching: true,
            customSlideAdvancement: true,
            initialSlide: startIndex
          } 
        }
        this.$thumbSlider.slick(window.thumbSliderSettings());
      }

      this.settings.slickInitialized = true;
    },

    destroyImageCarousels: function() {
      if (!this.settings.slickInitialized) {
        return;
      }

      if (this.$mainSlider.length && this.$mainSlider.hasClass('slick-initialized')) {
        this.$mainSlider.slick('unslick');
      }

      if (this.$thumbSlider.length && this.$thumbSlider.hasClass('slick-initialized')) {
        this.$thumbSlider.slick('unslick');
      }

      this.settings.slickInitialized = false;
    },

    mainSlideInit: function(event, slick) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find('.' + classes.currentSlide);
      var $video = $currentSlide.find('.' + classes.productVideo);

      if (!$video.length) {
        return;
      }

      this.initVideo($video);
    },

    initVideo: function($video) {
      var videoType = $video.data('video-type');
      var divId = $video.attr('id');

      if (videoType === 'mp4' && videos[divId].style === 'muted') {
        this.playMp4Video(divId);
      }

      if (videoType === 'youtube') {
        if (youtubeReady && videos[divId].style === 'muted') {
          this.requestToPlayYoutubeVideo(divId);
        }
      }

      if (videoType === 'vimeo') {
        if (vimeoReady && videos[divId].styles === 'muted') {
          // Because the vimeo API might not be ready, this autoplay check
          // is handled elsewhere
          this.autoplayVimeoVideo(divId);
        }
      }

      // Hacky way to trigger resetting the slider layout in modals
      if (this.inModal) {
        this.resizeSlides();
      }
    },

    getVideoType: function($video) {
      return $video.data('video-type');
    },

    getVideoId: function($video) {
      return $video.attr('id');
    },

    beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find('.' + classes.currentSlide);
      var $prevVideo = $currentSlide.find('.product__video');
      var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
      var $nextVideo = $nextSlide.find('.product__video');

      // Pause any existing slide video
      if (currentSlide !== nextSlide && $prevVideo.length) {
        var prevVideoType = this.getVideoType($prevVideo);
        var prevVideoId = this.getVideoId($prevVideo);

        if (prevVideoId) {
          if (prevVideoType === 'youtube') {
            this.stopYoutubeVideo(prevVideoId);
          }

          if (prevVideoType === 'mp4') {
            this.stopMp4Video(prevVideoId);
          }

          if (prevVideoType === 'vimeo') {
            this.stopVimeoVideo(prevVideoId);
          }
        }
      }

      // Prep next slide video
      if ($nextVideo.length) {
        var nextVideoType = this.getVideoType($nextVideo);
        var nextVideoId = this.getVideoId($nextVideo);

        // Prep Vimeo with a backup in case the API isn't ready
        if (nextVideoId && nextVideoType === 'vimeo') {
          if (vimeoReady) {
            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
              this.autoplayVimeoVideo(nextVideoId);
            }
          } else {
            $('body').on('vimeoReady' + this.settings.namespace, function() {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.autoplayVimeoVideo(nextVideoId);
              }
            }.bind(this))
          }
        }

        // Prep YouTube with a backup in case API isn't ready
        if (nextVideoId && nextVideoType === 'youtube') {
          if (youtubeReady) {
            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
              this.requestToPlayYoutubeVideo(nextVideoId, true);
            }
          } else {
            $('body').on('youTubeReady' + this.settings.namespace, function() {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            }.bind(this))
          }
        }

        // Autoplay muted MP4 videos
        if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
          if (nextVideoType === 'mp4') {
            this.playMp4Video(nextVideoId);
          }
        }

        // Set unmuted videos to loaded state
        if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
          setParentAsLoaded($('#' + nextVideoId));
        }
      }

      // Layload zoom image
      if (this.settings.zoom) {
        if ($nextSlide.hasClass(classes.zoomInit)) {
          return;
        }
        var $image = $nextSlide.addClass(classes.zoomInit).find('img').addClass('lazyload');
        this.initZoom($image);
      }
    },

    resizeSlides: function() {
      if (!this.settings.hasMultipleImages) {
        return;
      }

      $(window).trigger('resize');
      setTimeout(function() {
        if (this.$mainSlider.length && this.$mainSlider.hasClass('slick-initialized')) {
          this.$mainSlider.slick('setPosition');
        }
        if (this.$thumbSlider.length && this.$thumbSlider.hasClass('slick-initialized')) {
          this.$thumbSlider.slick('setPosition');
        }
      }.bind(this), 500); // same timing as modal open transition
    },

    _slideIndex: function($el) {
      return $el.data('index');
    },

    // Ajax cart and qty
    initQtySelector: function() {
      this.$container.find('.js-qty').each(function() {
        new theme.QtySelector($(this), {
          namespace: '.product'
        });
      });
    },

	    initProductFormGuard: function() {
	      this.$productForm = $(this.selectors.formContainer);

	      if (!this.$productForm.length) {
	        return;
      }

	      var formElement = this.$productForm[0];
	      var addToCartButton = $(this.selectors.addToCart)[0] || null;
	      var product = this;

	      if (formElement.__themeProductGuardState) {
	        this.destroyProductFormGuard(formElement.__themeProductGuardState);
	      }

	      this.$productForm.data('themeProductController', this);
	      formElement.__themeProductController = this;
	      var guardEvent = function(evt) {
	        var validation = product.validateProductFormSubmission({
	          reason: 'product-form-submit-guard',
	          focusOnError: true
        });

        if (validation.valid) {
          return;
        }

        if (evt && typeof evt.preventDefault === 'function') {
          evt.preventDefault();
        }

        if (evt && typeof evt.stopImmediatePropagation === 'function') {
	          evt.stopImmediatePropagation();
	        }
	      };

	      var guardState = {
	        controller: this,
	        formElement: formElement,
	        addToCartButton: addToCartButton,
	        submitHandler: guardEvent,
	        clickHandler: addToCartButton ? guardEvent : null,
	        originalSubmit: formElement.submit
	      };

	      formElement.addEventListener('submit', guardState.submitHandler, true);

	      if (guardState.addToCartButton && guardState.clickHandler) {
	        guardState.addToCartButton.addEventListener('click', guardState.clickHandler, true);
	      }

	      formElement.submit = function() {
	        var activeGuard = formElement.__themeProductGuardState || guardState;
	        var controller = activeGuard.controller || product;
	        var validation = controller.validateProductFormSubmission({
	          reason: 'product-form-direct-submit',
	          focusOnError: true
	        });

	        if (!validation.valid) {
	          return;
	        }

	        return activeGuard.originalSubmit.call(formElement);
	      };

	      formElement.__themeProductGuardState = guardState;
	      formElement.__themeProductGuardBound = true;
	      this.productFormGuard = guardState;
	    },

	    destroyProductFormGuard: function(guardState) {
	      guardState = guardState || this.productFormGuard || (
	        this.$productForm && this.$productForm.length ? this.$productForm[0].__themeProductGuardState : null
	      );

	      if (!guardState || !guardState.formElement) {
	        return;
	      }

	      var formElement = guardState.formElement;
	      var $form = $(formElement);

	      if (guardState.submitHandler) {
	        formElement.removeEventListener('submit', guardState.submitHandler, true);
	      }

	      if (guardState.addToCartButton && guardState.clickHandler) {
	        guardState.addToCartButton.removeEventListener('click', guardState.clickHandler, true);
	      }

	      if (guardState.originalSubmit) {
	        formElement.submit = guardState.originalSubmit;
	      }

	      if (formElement.__themeProductGuardState === guardState) {
	        delete formElement.__themeProductGuardState;
	      }

	      delete formElement.__themeProductGuardBound;

	      if (formElement.__themeProductController === guardState.controller || formElement.__themeProductController === this) {
	        delete formElement.__themeProductController;
	      }

	      if ($form.length) {
	        $form.removeData('themeProductController');
	      }

	      if (this.productFormGuard === guardState) {
	        this.productFormGuard = null;
	      }
	    },

    initAjaxProductForm: function() {
      if (theme.settings.cartType === 'drawer') {
        new theme.AjaxProduct($(this.selectors.formContainer));
      }
    },

    openModalProduct: function() {
      if (!this.settings.modalInit) {
        this.loadModalContent();
        this.createImageCarousels();
        this.settings.modalInit = true;
      }

      this.resizeSlides();
    },

    closeModalProduct: function() {
      this.stopYoutubeVideo();
      this.stopVimeoVideo();
      this.stopMp4Video();
    },

    loadModalContent: function() {
      if (this.settings.modalContentLoaded) {
        return;
      }

      // Load images
      var imageCount = $(this.selectors.photoThumbs).length * 2; // thumbs and main images
      var loadCount = 0;

      this.$modal.find('img[data-modal-lazy]').each(function(i, img) {
        var $el = $(img);
        var image = $el.data('modal-lazy');
        $el.attr('src', image);
        loadCount++;

        if (loadCount == imageCount) {
          this.settings.modalContentLoaded = true;
        }
      }.bind(this));

      // Load videos if they exist
      var videoTypes = this.checkIfVideos();

      // Lazyload mp4 videos similar to images
      if (videoTypes && videoTypes.indexOf('mp4') > -1) {
        this.$modal.find('.product__video[data-video-type="mp4"]').each(function(i, video) {
          var $el = $(video);
          var src = $el.data('video-src');
          var source = document.createElement('source');
          source.setAttribute('src', src);
          $el.append(source);
        }.bind(this));
      }
    },

	    onUnload: function() {
      this.setProductFormReady(false);
	      this.destroyProductFormGuard();
	      this.$container.off(this.settings.namespace);
	      $(window).off(this.settings.namespace);
	      $(document).off(this.settings.namespace);
	      $('body').off(this.settings.namespace);
      this.destroyImageCarousels();
    }
  });

  return Product;
})();

theme.productGridSwatches = {
  initialized: false,
  selectors: {
    card: '[data-grid-product-swatches]',
    swatch: '[data-grid-product-swatches] .color-swatch',
    swatchContainer: '[data-grid-product-swatches] .grid-product__colors',
    primaryImage: '.grid-product__image',
    secondaryImage: '.grid-product__secondary-image'
  },

  init: function() {
    if (this.initialized) {
      return;
    }

    this.initialized = true;

    $(document)
      .on('mouseenter.productGridSwatches focusin.productGridSwatches', this.selectors.swatch, this.handlePreview.bind(this))
      .on('mouseleave.productGridSwatches', this.selectors.swatchContainer, this.handleRestore.bind(this))
      .on('focusout.productGridSwatches', this.selectors.swatchContainer, this.handleFocusOut.bind(this))
      .on('click.productGridSwatches', this.selectors.swatch, this.handleSelect.bind(this));
  },

  getCard: function(element) {
    return $(element).closest(this.selectors.card);
  },

  applyImage: function($card, $swatch) {
    if (!$card.length || !$swatch.length) {
      return;
    }

    var imageUrl = $swatch.attr('data-swatch-image');
    if (!imageUrl) {
      return;
    }

    var imageAlt = $swatch.attr('data-swatch-image-alt') || '';
    var secondaryImageUrl = $swatch.attr('data-swatch-secondary-image') || imageUrl;
    var $primaryImage = $card.find(this.selectors.primaryImage).first();
    var $secondaryImage = $card.find(this.selectors.secondaryImage).first();

    if ($primaryImage.length) {
      $primaryImage.attr('src', imageUrl);
      $primaryImage.attr('alt', imageAlt);
    }

    if ($secondaryImage.length) {
      $secondaryImage.css('background-image', secondaryImageUrl ? 'url("' + secondaryImageUrl + '")' : '');
    }
  },

  restoreImage: function($card) {
    if (!$card.length) {
      return;
    }

    var $activeSwatch = $card.find(this.selectors.swatch + '.is-active').first();
    if ($activeSwatch.length) {
      this.applyImage($card, $activeSwatch);
      return;
    }

    var $primaryImage = $card.find(this.selectors.primaryImage).first();
    var $secondaryImage = $card.find(this.selectors.secondaryImage).first();

    if ($primaryImage.length) {
      var defaultImage = $primaryImage.attr('data-default-image');
      var defaultAlt = $primaryImage.attr('data-default-alt') || '';

      if (defaultImage) {
        $primaryImage.attr('src', defaultImage);
      }
      $primaryImage.attr('alt', defaultAlt);
    }

    if ($secondaryImage.length) {
      var defaultSecondaryImage = $secondaryImage.attr('data-default-image');
      $secondaryImage.css('background-image', defaultSecondaryImage ? 'url("' + defaultSecondaryImage + '")' : '');
    }
  },

  handlePreview: function(evt) {
    var $swatch = $(evt.currentTarget);
    this.applyImage(this.getCard($swatch), $swatch);
  },

  handleRestore: function(evt) {
    this.restoreImage(this.getCard(evt.currentTarget));
  },

  handleFocusOut: function(evt) {
    var self = this;
    var $container = $(evt.currentTarget);

    window.setTimeout(function() {
      if ($container.find(document.activeElement).length) {
        return;
      }

      self.restoreImage(self.getCard($container));
    }, 0);
  },

  handleSelect: function(evt) {
    var $swatch = $(evt.currentTarget);
    var $card = this.getCard($swatch);

    $card.find(this.selectors.swatch).removeClass('is-active');
    $swatch.addClass('is-active');
    this.applyImage($card, $swatch);
  }
};


theme.Collection = (function() {
  var selectors = {
    ajaxResult: '#CollectionAjaxResult',
    ajaxContent: '#CollectionAjaxContent',
    storefrontFilterLinks: '.collection-filter__value-link, .collection-filter__clear-link',
    storefrontFilterDropdowns: '.collection-filter__dropdown',
    storefrontFilterDropdownToggles: '.collection-filter__dropdown-toggle'
  };

  var classes = {
    tags: '.tags',
    activeTag: 'tag--active'
  };

  function Collection(container) {
    this.container = container;
    this.$container = $(container);
    this.sectionId = this.$container.attr('data-section-id');
    this.namespace = '.collection-' + this.sectionId;

    theme.preloadImages(container);

    // Ajax pagination
    $(window).on('popstate' + this.namespace, function(state) {
      if (state) {
        this.getNewCollectionContent(location.href);
      }
    }.bind(this));

    this.init();
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    init: function() {
      // init is called on load and when tags are selected
      this.$container = $(this.container);
      this.sectionId = this.$container.attr('data-section-id');

      this.sortBy();
      this.sortTags();
      this.initTagAjax();
      this.initStorefrontFilterDropdowns();
      this.initStorefrontFilterAjax();
    },

    initTagAjax: function() {
      this.$container.on('click' + this.namespace, '.tags a', function(evt) {
        evt.preventDefault();
        var $el = $(evt.currentTarget);
        var newUrl = $el.attr('href');
        $(classes.tags).find('.' + classes.activeTag).removeClass(classes.activeTag);
        $el.parent().addClass(classes.activeTag);
        history.pushState({}, '', newUrl);
        $('.grid-product').addClass('unload');
        this.getNewCollectionContent(newUrl);
      }.bind(this));
    },

    getNewCollectionContent: function(url) {
      var $ajaxResult = $(selectors.ajaxResult);

      if (!$ajaxResult.length) {
        window.location.href = url;
        return;
      }

      $ajaxResult.load(url + ' ' + selectors.ajaxContent, function() {
        if (!$ajaxResult.find(selectors.ajaxContent).length) {
          window.location.href = url;
          return;
        }

        this.reInit();
      }.bind(this));
    },

    shouldHandleCollectionAjaxClick: function(evt, url, $el) {
      if (!url) {
        return false;
      }

      // Let modified clicks behave like normal links (new tab/window, etc).
      if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || evt.which > 1) {
        return false;
      }

      var target = $el.attr('target');
      if (target && target !== '_self') {
        return false;
      }

      if ($el.is('[download]')) {
        return false;
      }

      if (!$(selectors.ajaxResult).length || !$(selectors.ajaxContent).length) {
        return false;
      }

      var link = document.createElement('a');
      link.href = url;

      // Only intercept same-origin links.
      if (link.host && link.host !== window.location.host) {
        return false;
      }

      return true;
    },

    initStorefrontFilterDropdowns: function() {
      this.$container.on('click' + this.namespace, selectors.storefrontFilterDropdownToggles, function(evt) {
        var $dropdown = $(evt.currentTarget).closest(selectors.storefrontFilterDropdowns);

        // Only enforce single-open when the clicked dropdown is opening.
        if (!$dropdown.prop('open')) {
          this.$container
            .find(selectors.storefrontFilterDropdowns)
            .not($dropdown)
            .prop('open', false);
        }
      }.bind(this));
    },

    initStorefrontFilterAjax: function() {
      this.$container.on('click' + this.namespace, selectors.storefrontFilterLinks, function(evt) {
        var $el = $(evt.currentTarget);
        var newUrl = $el.attr('href');

        if (!this.shouldHandleCollectionAjaxClick(evt, newUrl, $el)) {
          return;
        }

        evt.preventDefault();
        history.pushState({}, '', newUrl);
        $('.grid-product').addClass('unload');
        this.getNewCollectionContent(newUrl);
      }.bind(this));
    },

    sortBy: function() {
      var $sortBy = this.$container.find('#SortBy');

      if (!$sortBy.length) {
        return;
      }

      $sortBy.on('change', function() {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', $(this).val());
        params.delete('page');
        window.location.search = params.toString();
      });
    },

    sortTags: function() {
      var $sortTags = $('#SortTags');

      if (!$sortTags.length) {
        return;
      }

      $sortTags.on('change', function() {
        location.href = $(this).val();
      });
    },

    reInit: function() {
      // Reload collection template (it can be anywhere in the sections.instance array)
      for (var i = 0; i < sections.instances.length; i++) {
        var instance = sections.instances[i];
        if (instance['type'] === 'collection-template') {
          instance.forceReload();
        }
      }

      // Reload quick shop buttons
      theme.initQuickShop();

      // Reload products inside each quick shop
      sections.register('product-template', theme.Product);
    },

    forceReload: function() {
      this.onUnload();
      this.init();
    },

    onUnload: function() {
      $(window).off(this.namespace);
      this.$container.off(this.namespace);
    }

  });

  return Collection;
})();

theme.HeaderSection = (function() {

  var selectors = {
    drawer: '#NavDrawer',
    mobileSubNavToggle: '.mobile-nav__toggle-btn',
    hasSublist: '.mobile-nav__has-sublist'
  };

  var classes = {
    navExpanded: 'mobile-nav--expanded'
  };

  function Header(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Reload any slideshow if when the header is reloaded to make sure the
    // sticky header works as expected (it can be anywhere in the sections.instance array)
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];
      if (instance['type'] === 'slideshow-section') {
        instance.forceReload();
      }
    }

    theme.currencySwitcher.init()
    this.initDrawers();
    theme.headerNav.init();
    theme.announcementBar.init();
  }

  Header.prototype = $.extend({}, Header.prototype, {
    initDrawers: function() {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
      if (theme.settings.cartType === 'drawer') {
        new theme.CartDrawer();
      }

      this.drawerMenuButtons();
    },

    drawerMenuButtons: function() {
      $(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
        evt.preventDefault();
        theme.NavDrawer.close();
      });

      var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);

      $mobileSubNavToggle.attr('aria-expanded', 'false');
      $mobileSubNavToggle.each(function (i, el) {
        var $el = $(el);
        $el.attr('aria-controls', $el.attr('data-aria-controls'));
      });

      $mobileSubNavToggle.on('click', function() {
        var $el = $(this);
        var currentlyExpanded = $el.attr('aria-expanded');
        var toggleState = false;

        // Updated aria-expanded value based on state pre-click
        if (currentlyExpanded === 'true') {
          $el.attr('aria-expanded', 'false');
        } else {
          $el.attr('aria-expanded', 'true');
          toggleState = true;
        }

        // Toggle class that expands/collapses sublist
        $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
      });
    },

    onUnload: function() {
      theme.NavDrawer.close();
      theme.headerNav.unload();
    }
  });

  return Header;

})();

theme.FeaturedContentSection = (function() {

  function FeaturedContent() {
    $('.rte').find('a:not(:has(img))').addClass('text-link');
  }

  return FeaturedContent;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {

  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var $section = $container.parent();
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.preloadImages(container);

    this.init();
  }

  SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
    init: function() {
      theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, null);
    },

    forceReload: function() {
      this.onUnload();
      this.init();
    },

    onUnload: function() {
      theme.slideshows[this.slideshow].destroy();
      delete theme.slideshows[this.slideshow];
    },

    onSelect: function() {
      $(this.slideshow).slick('slickPause');
    },

    onDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    }
  });

  return SlideshowSection;
})();

theme.VideoSection = (function() {
  var youtubeReady;
  var videos = [];
  var youtubePlayers = [];
  var youtubeVideoOptions = {
    width: 1280,
    height: 720,
    playerVars: {
      autohide: 0,
      branding: 0,
      cc_load_policy: 0,
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    },
    events: {
      onReady: onVideoPlayerReady,
      onStateChange: onVideoStateChange
    }
  };

  var vimeoReady = false;
  var vimeoVideoOptions = {
    byline: false,
    title: false,
    portrait: false,
    loop: true
  };

  var selectors = {
    videoParent: '.video-parent-section'
  };

  var classes = {
    loading: 'loading',
    preloaded: 'preloaded',
    interactable: 'video-interactable'
  };

  function videoSection(container) {
    if (theme.config.isIframe) {
      return;
    }
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
    this.namespace = '.' + youtubePlayerId;
    var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
    var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
    var mp4Video = 'Mp4Video-' + this.sectionId;

    var $youtubeDiv = $('#' + youtubePlayerId);
    var $vimeoDiv = $('#' + vimeoPlayerId);
    var $mp4Div = $('#' + mp4Video);

    this.vimeoPlayer = [];

    if ($youtubeDiv.length) {
      this.youtubeVideoId = $youtubeDiv.data('video-id');
      this.initYoutubeVideo();
    }

    if ($vimeoDiv.length) {
      this.vimeoVideoId = $vimeoDiv.data('video-id');
      this.initVimeoVideo();
    }

    if ($mp4Div.length) {
      setParentAsLoaded($mp4Div);

      startMp4Playback(mp4Video).then(function() {
        // Video played as expected, don't do anything
      }).catch(function(error) {
        // Video cannot be played with autoplay, so let
        // user interact with video element itself
        setVideoToBeInteractedWith($mp4Div);
      })
    }
  }

  function startMp4Playback(mp4Video) {
    return document.querySelector('#' + mp4Video).play();
  }

  function onVideoPlayerReady(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    youtubePlayers[playerId] = evt.target; // update stored player
    var player = youtubePlayers[playerId];

    setParentAsLoading($player);

    youtubePlayers[playerId].mute();

    // Remove from tabindex because YouTube iframes are annoying and you can focus
    // on the YouTube logo and it breaks
    $player.attr('tabindex', '-1');

    // Add out of view pausing
    videoVisibilityCheck(playerId);
    $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
  }

  function videoVisibilityCheck(id) {
    var playerId;

    if (typeof id === 'string') {
      playerId = id;
    } else {
      // Data comes in as part of the scroll event
      playerId = id.data.id;
    }

    if (theme.isElementVisible($('#' + playerId))) {
      playVisibleVideo(playerId);
    } else {
      pauseHiddenVideo(playerId);
    }
  }

  function playVisibleVideo(id) {
    if (typeof youtubePlayers[id].playVideo === 'function') {
      youtubePlayers[id].playVideo();
    }
  }

  function pauseHiddenVideo(id) {
    if (typeof youtubePlayers[id].pauseVideo === 'function') {
      youtubePlayers[id].pauseVideo();
    }
  }

  function onVideoStateChange(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    var player = youtubePlayers[playerId];

    switch (evt.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (videos[playerId].attemptedToPlay) {
          setParentAsLoaded($player);
          setVideoToBeInteractedWith($player);
        }
        break;
      case 0: // ended
        player.playVideo();
        break;
      case 1: // playing
        setParentAsLoaded($player);
        break;
      case 3: // buffering
        videos[playerId].attemptedToPlay = true;
        break;
    }
  }

  function setParentAsLoading($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.loading);
  }

  function setParentAsLoaded($el) {
    $el
      .closest(selectors.videoParent)
      .removeClass(classes.loading)
      .addClass(classes.preloaded);
  }

  function setVideoToBeInteractedWith($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.interactable);
  }

  videoSection.prototype = $.extend({}, videoSection.prototype, {
    initYoutubeVideo: function() {
      videos[this.youtubePlayerId] = {
        id: this.youtubePlayerId,
        videoId: this.youtubeVideoId,
        type: 'youtube',
        attemptedToPlay: false
      };

      if (!youtubeReady) {
        window.loadYouTube();
        $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
      } else {
        this.loadYoutubeVideo();
      }
    },

    loadYoutubeVideo: function() {
      var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
      args.playerVars.controls = 0;
      youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);

      youtubeReady = true;
    },

    initVimeoVideo: function() {
      videos[this.vimeoPlayerId] = {
        divId: this.vimeoPlayerId,
        id: this.vimeoVideoId,
        type: 'vimeo'
      };

      var $player = $('#' + this.vimeoPlayerId);
      setParentAsLoading($player);

      // Button to play video on mobile
      this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
        // $(evt.currentTarget).addClass('hide');
        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
      }.bind(this));

      if (!vimeoReady) {
        window.loadVimeo();
        $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
      } else {
        this.loadVimeoVideo();
      }
    },

    loadVimeoVideo: function() {
      var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
      this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);

      vimeoReady = true;

      // Only autoplay on larger screens
      if (!theme.config.bpSmall) {
        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
      } else {
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoaded($player);
      }
    },

    requestToPlayVimeoVideo: function(id) {
      // The slider may initialize and attempt to play the video before
      // the API is even ready, because it sucks.

      if (!vimeoReady) {
        // Wait for the trigger, then play it
        $('body').on('vimeoReady' + this.namespace, function() {
          this.playVimeoVideo(id);
        }.bind(this))
        return;
      }

      this.playVimeoVideo(id);
    },

    playVimeoVideo: function(id) {
      this.vimeoPlayer[id].play();
      this.vimeoPlayer[id].setVolume(0);

      var $player = $('#' + id);
      setParentAsLoaded($player);
    },

    onUnload: function(evt) {
      var sectionId = evt.target.id.replace('shopify-section-', '');
      var playerId = 'YouTubeVideo-' + sectionId;
      youtubePlayers[playerId].destroy();
      $(window).off('scroll' + this.namespace);
      $('body').off('vimeoReady' + this.namespace);
    }
  });

  return videoSection;
})();

theme.Testimonials = (function() {
  var slideCount = 0;
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Testimonials(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.testimonials-wrapper';
    var slider = this.slider = '#Testimonials-' + sectionId;
    var $slider = $(slider);

    this.sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = slideCount;
      defaults.slidesToScroll = slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    if (theme.config.bpSmall) {
      this.init($slider, mobileOptions);
    } else {
      this.init($slider, defaults);
    }

    $('body').on('matchSmall', function() {
      this.init($slider, mobileOptions);
    }.bind(this));

    $('body').on('matchLarge', function() {
      this.init($slider, defaults);
    }.bind(this));
  }

  Testimonials.prototype = $.extend({}, Testimonials.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    init: function(obj, args) {
      if (this.sliderActive) {
        obj.slick('unslick');
        this.sliderActive = false;
      }

      obj.slick(args);
      this.sliderActive = true;
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Testimonials;
})();

theme.Instagram = (function() {
  var defaults = {

  };

  function Instagram(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var $target = $('#Instafeed-' + sectionId);

    if (!$target.length) {
      return;
    }

    var userId = $target.data('user-id');
    var clientId = $target.data('client-id');
    var count = $target.data('count');

    var feed = this.feed = new Instafeed({
      target: $target[0],
      accessToken: clientId,
      get: 'user',
      userId: userId,
      limit: count,
      template: '<div class="grid__item small--one-half medium-up--one-fifth" data-aos="row-of-5"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover;"></a></div></div>',
      resolution: 'standard_resolution'
    });

    feed.run();
  }

  Instagram.prototype = $.extend({}, Instagram.prototype, {
    onUnload: function() {

    }
  });

  return Instagram;
})();


theme.NewsletterPopup = (function() {
  function NewsletterPopup(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.cookieName = 'newsletter-' + sectionId;

    if (!$container.length) {
      return;
    }

    this.data = {
      secondsBeforeShow: $container.data('delay-seconds'),
      daysBeforeReappear: $container.data('delay-days'),
      cookie: $.cookie(this.cookieName),
      testMode: $container.data('test-mode')
    };

    this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

    // Open modal if errors or success message exist
    if ($container.find('.errors').length || $container.find('.note--success').length) {
      this.modal.open();
    }

    // Set cookie as opened if success message
    if ($container.find('.note--success').length) {
      this.closePopup();
      return;
    }

    $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));

    if (!this.data.cookie || this.data.testMode) {
      this.initPopupDelay();
    }
  }

  NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
    initPopupDelay: function() {
      setTimeout(function() {
        this.modal.open();
      }.bind(this), this.data.secondsBeforeShow * 1000);
    },

    closePopup: function() {
      // Remove a cookie in case it was set in test mode
      if (this.data.testMode) {
        $.removeCookie(this.cookieName, { path: '/' });
        return;
      }

      $.cookie(this.cookieName, 'opened', { expires: this.data.daysBeforeReappear });
    },

    onLoad: function() {
      this.modal.open();
    },

    onSelect: function() {
      this.modal.open();
    },

    onDeselect: function() {
      this.modal.close();
    },

    onUnload: function() {}
  });

  return NewsletterPopup;
})();

theme.FadingImages = (function() {

  var classes = {
    activeImage: 'active-image',
    finishedImage: 'finished-image',
    activeTitles: 'active-titles',
    finishedTitles: 'finished-titles',
    compensation: 'compensation'
  };

  function FadingImages(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var namespace = this.namespace = '.fading-images-' + sectionId;

    if (!$container.length) {
      return;
    }

    theme.preloadImages(container);

    this.data = {
      isInit: false,
      interval: $container.data('interval'),
      block_count: $container.data('count'),
      finish_interval: 1000,
      timer_offset: 400,
      active_image: 1,
      active_title: 1,
      removed_compensation: false
    };

    this.selectors = {
      $allTitles: $container.find('.fading-images-overlay__titles')
    };

    this.checkVisibility();
    $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
  }

  FadingImages.prototype = $.extend({}, FadingImages.prototype, {
    checkVisibility: function() {
      if (this.data.isInit) {
        $(window).off('scroll' + this.namespace);
        return;
      }

      if (theme.isElementVisible(this.$container) && this.$container.find('.fading-images').hasClass('preloaded')) {
        this.startImages();
        this.startTitles();
        this.data.isInit = true;
      }
    },

    nextImage: function() {
      var $container = this.$container;

      if (!this.data.removed_compensation) {
        $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').removeClass(classes.compensation);
        this.data.removed_compensation = true;
      }

      $container
        .find('.fading-images__item[data-slide-index=' + this.data.active_image + ']')
        .removeClass(classes.activeImage)
        .addClass(classes.finishedImage);

      var target_image = this.data.active_image;
      window.setTimeout(function() {
        $container.find('.fading-images__item[data-slide-index=' + target_image + ']').removeClass(classes.finishedImage);
      }, this.data.finish_interval);

      this.data.active_image++;
      if (this.data.active_image > this.data.block_count) {
        this.data.active_image = 1;
      }

      $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage);
    },

    nextTitle: function() {
      var $container = this.$container;
      var $allTitles = this.selectors.$allTitles;

      this.selectors.$allTitles.removeClass(classes.activeTitles).addClass(classes.finishedTitles);

      this.data.active_title++;
      if (this.data.active_title > this.data.block_count) {
        this.data.active_title = 1;
      }

      var target_title = this.data.active_title;
      window.setTimeout(function() {
        var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
        var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
        $container.find('.fading-images-overlay__title--1').text(newText1);
        $container.find('.fading-images-overlay__title--2').text(newText2);
        $allTitles.removeClass(classes.finishedTitles).addClass(classes.activeTitles);
      }, this.data.finish_interval - 200);
    },

    startImages: function() {
      // Prep and show first image
      this.$container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage).addClass(classes.compensation);

      // Begin timer
      var o = this;
      window.setTimeout(function() {
        var fading_images_timer = window.setInterval(o.nextImage.bind(o), o.data.interval);
      }, this.data.timer_offset);
    },

    startTitles: function() {
      var $container = this.$container;
      var $allTitles = this.selectors.$allTitles;
      // Prep and show first titles
      var target_title = this.data.active_title;
      window.setTimeout(function() {
        var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
        var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
        $container.find('.fading-images-overlay__title--1').text(newText1);
        $container.find('.fading-images-overlay__title--2').text(newText2);
        $allTitles.addClass(classes.activeTitles);
      }, 750);

      // Begin timer
      var fading_titles_timer = window.setInterval(this.nextTitle.bind(this), this.data.interval);
    },

    onLoad: function() {
    },

    onSelect: function() {
    },

    onDeselect: function() {
    },

    onUnload: function() {
    }
  });

  return FadingImages;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.sectionId = this.$container.attr('data-section-id');
    this.namespace = '.map-' + this.sectionId;
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (!this.key) {
      return;
    }

    // Lazyload API
    this.checkVisibility();
    $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = $.extend({}, Map.prototype, {
    prepMapApi: function() {
      if (apiStatus === 'loaded') {
        this.createMap();
      } else {
        mapsToLoad.push(this);

        if (apiStatus !== 'loading') {
          apiStatus = 'loading';
          if (typeof window.google === 'undefined') {
            $.getScript(
              'https://maps.googleapis.com/maps/api/js?key=' + this.key
            ).then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
          }
        }
      }
    },

    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              backgroundColor: 'none',
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    checkVisibility: function() {
      if (theme.isElementVisible(this.$container)) {
        this.prepMapApi();
        $(window).off(this.namespace);
      }
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      // Causes a harmless JS error when a section without an active map is reloaded
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

theme.Blog = (function() {

  function Blog(container) {
    this.tagFilters();
  }

  Blog.prototype = $.extend({}, Blog.prototype, {
    tagFilters: function() {
      var $filterBy = $('#BlogTagFilter');

      if (!$filterBy.length) {
        return;
      }

      $filterBy.on('change', function() {
        location.href = $(this).val();
      });
    },

    onUnload: function() {

    }
  });

  return Blog;
})();

theme.LandingCollectionsHover = (function() {
  var classes = {
    active: 'is-active'
  };

  var selectors = {
    trigger: '[data-collection-trigger]',
    panel: '[data-collection-panel]',
    grid: '.landing-collections-hover__grid',
    mediaStack: '.landing-collections-hover__media-stack',
    count: '.landing-collections-hover__count'
  };

  function LandingCollectionsHover(container) {
    this.$container = $(container);
    this.sectionId = this.$container.attr('data-section-id');
    this.namespace = '.landing-collections-hover-' + this.sectionId;
    this.$triggers = this.$container.find(selectors.trigger);
    this.$panels = this.$container.find(selectors.panel);
    this.$grid = this.$container.find(selectors.grid);
    this.$mediaStack = this.$container.find(selectors.mediaStack);
    this.$counts = this.$container.find(selectors.count);

    this.settings = {
      minHeight: parseInt(this.$container.attr('data-min-height'), 10),
      inactiveOpacity: parseFloat(this.$container.attr('data-inactive-opacity')),
      textColor: this.$container.attr('data-text-color'),
      countColor: this.$container.attr('data-count-color')
    };

    if (isNaN(this.settings.minHeight)) {
      this.settings.minHeight = 680;
    }

    if (isNaN(this.settings.inactiveOpacity)) {
      this.settings.inactiveOpacity = 0.35;
    }

    this.applySectionStyles();

    if (!this.$triggers.length || !this.$panels.length) {
      return;
    }

    this.bindEvents();

    var defaultIndex = parseInt(this.$container.attr('data-default-index'), 10);
    if (isNaN(defaultIndex)) {
      defaultIndex = 0;
    }

    this.setActive(defaultIndex);
  }

  LandingCollectionsHover.prototype = $.extend({}, LandingCollectionsHover.prototype, {
    applySectionStyles: function() {
      this.$grid.css('min-height', this.settings.minHeight + 'px');
      this.$mediaStack.css('min-height', this.settings.minHeight + 'px');

      if (this.settings.textColor) {
        this.$triggers.css('color', this.settings.textColor);
      }

      if (this.settings.countColor) {
        this.$counts.css('color', this.settings.countColor);
      }

      this.$triggers.css('opacity', this.settings.inactiveOpacity);
    },

    bindEvents: function() {
      this.$triggers
        .on('mouseenter' + this.namespace, this.onTriggerInteraction.bind(this))
        .on('focus' + this.namespace, this.onTriggerInteraction.bind(this));
    },

    onTriggerInteraction: function(event) {
      var index = parseInt($(event.currentTarget).attr('data-index'), 10);
      if (isNaN(index)) {
        return;
      }

      this.setActive(index);
    },

    setActive: function(index) {
      var triggerCount = this.$triggers.length;
      if (!triggerCount) {
        return;
      }

      var safeIndex = index;
      if (safeIndex < 0) {
        safeIndex = 0;
      } else if (safeIndex >= triggerCount) {
        safeIndex = triggerCount - 1;
      }

      this.$triggers
        .removeClass(classes.active)
        .removeAttr('aria-current')
        .css('opacity', this.settings.inactiveOpacity)
        .filter('[data-index="' + safeIndex + '"]')
        .addClass(classes.active)
        .attr('aria-current', 'true')
        .css('opacity', 1);

      this.$panels
        .removeClass(classes.active)
        .attr('aria-hidden', 'true')
        .filter('[data-index="' + safeIndex + '"]')
        .addClass(classes.active)
        .attr('aria-hidden', 'false');
    },

    onBlockSelect: function(event) {
      var $selectedBlock = $(event.target);
      var index = parseInt($selectedBlock.attr('data-index'), 10);

      if (isNaN(index)) {
        index = parseInt($selectedBlock.find(selectors.trigger).first().attr('data-index'), 10);
      }

      if (!isNaN(index)) {
        this.setActive(index);
      }
    },

    onUnload: function() {
      this.$triggers.off(this.namespace);
    }
  });

  return LandingCollectionsHover;
})();

theme.inIframe = function() {
  try {
    return parent.document.location.hostname !== document.location.hostname;
  } catch (e) {
    return true;
  }
}

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  mediaQuerySmall: 'screen and (max-width: 589px)',
  mediaQueryMediumUp: 'screen and (min-width: 590px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  preloadImages: true,
  isTouch: false,
  isIframe: theme.inIframe()
};

function onYouTubeIframeAPIReady() {
  theme.config.youTubeReady = true;
  $('body').trigger('youTubeReady');
}

function loadYouTube() {
  if (theme.config.youtubeReady) {
    return;
  }

  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function loadVimeo() {
  if (theme.config.vimeoLoading) {
    return;
  }

  if (!theme.config.vimeoReady) {
    theme.config.vimeoLoading = true;
    var tag = document.createElement('script');
    tag.src = "https://player.vimeo.com/api/player.js";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function() {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        $('body').trigger('vimeoReady');
      })
      .fail(function() {
        // No vimeo API to talk to
      });
  }
}

function checkIfVimeoIsReady() {
  var deferred = $.Deferred();
  var wait;
  var timeout;

  wait = setInterval(function() {
    if (!Vimeo) {
      return;
    }

    clearInterval(wait);
    clearTimeout(timeout);
    deferred.resolve();
  }, 500);

  timeout = setTimeout(function() {
    clearInterval(wait);
    deferred.reject();
  }, 4000); // subjective. test up to 8 times over 4 seconds

  return deferred;
}

theme.init = function() {
  theme.setGlobals();
  theme.pageTransitions();
  theme.initQuickShop();
  theme.videoModal();
  theme.articleImages.init();
  theme.backButton.init();
  theme.customerTemplates.init();
  theme.collapsibles.init();
  theme.productGridSwatches.init();

  slate.rte.wrapTable();

  AOS.init({
    easing: 'ease-out-quad',
    once: true
  });
};

theme.setGlobals = function() {
  theme.config.hasSessionStorage = theme.isSessionStorageSupported() || theme.config.isIframe;
  theme.config.ie = theme.ieVersion();

  if (theme.config.ie <= 9) {
    theme.config.preloadImages = false;
  }

  window.addEventListener('touchstart', function onFirstTouch() {
    theme.config.isTouch = true;
    window.removeEventListener('touchstart', onFirstTouch, false);
    $('body').addClass('supports-touch');
  });

  enquire.register(theme.config.mediaQuerySmall, {
    match: function() {
      theme.config.bpSmall = true;
      $('body').trigger('matchSmall');
    },
    unmatch: function() {
      theme.config.bpSmall = false;
      $('body').trigger('unmatchSmall');
    }
  });

  enquire.register(theme.config.mediaQueryMediumUp, {
    match: function() {
      $('body').trigger('matchLarge');
    },
    unmatch: function() {
      $('body').trigger('unmatchLarge');
    }
  });
};

theme.ieVersion = function() {
  var undef;
  var v = 3;
  var div = document.createElement('div');
  var all = div.getElementsByTagName('i');

  while (
    div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
    all[0]
  );

  return v > 4 ? v : undef;
};

theme.preloadImages = function(container) {
  if (!theme.config.preloadImages) {
    fauxPreloadImages(container);
    return;
  }

  preloadImages(container);
}

theme.isSessionStorageSupported = function() {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  var testKey = 'test';
  var storage = window.sessionStorage;
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

theme.isElementVisible = function($el) {
  return theme.isElementInViewport($el);
};

theme.isElementInViewport = function(el) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }

  var rect = el.getBoundingClientRect();

  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

theme.pageTransitions = function() {
  if ($('body').data('transitions') == true) {

    // Hack test to fix Safari page cache issue.
    // window.onpageshow doesn't always run when navigating
    // back to the page, so the unloading class remains, leaving
    // a white page. Setting a timeout to remove that class when leaving
    // the page actually finishes running when they come back.
    if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
      $('a').on('click', function() {
        window.setTimeout(function() {
          $('body').removeClass('unloading');
        }, 1200);
      });
    }

    // Add disable transition class to malito or anchor links
    $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], .shg-btn').each(function() {
      $(this).addClass('js-no-transition');
    });

    $('a:not(.js-no-transition)').bind('click', function(evt) {
      if (evt.metaKey) return true;
      evt.preventDefault();
      $('body').addClass('unloading');
      var src = $(this).attr('href');
      window.setTimeout(function() {
        location.href = src;
      }, 50);
    });

    $('.mobile-nav__link').bind('click', function() {
      theme.NavDrawer.close();
    });
  }
};

window.onpageshow = function(evt) {
  // Removes unload class when returning to page via history
  if (evt.persisted) {
    $('body').removeClass('unloading');
  }
};

$(document).ready(function() {
  theme.init();

  window.sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('video-section', theme.VideoSection);
  sections.register('product', theme.Product);
  sections.register('product-template', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('featured-content-section', theme.FeaturedContentSection);
  sections.register('testimonials', theme.Testimonials);
  sections.register('instagram', theme.Instagram);
  sections.register('newsletter-popup', theme.NewsletterPopup);
  sections.register('fading-images', theme.FadingImages);
  sections.register('map', theme.Maps);
  sections.register('blog', theme.Blog);
  sections.register('landing-collections-hover', theme.LandingCollectionsHover);
});
